// const goog = 'https://www.google.com/s2/favicons?domain='
// const ddg = 'https://icons.duckduckgo.com/ip3/'
const unv = 'https://unavatar.io/'
const src = unv
const img = 'legacy/img'

export const other = [
  // { key: 'www.ercot.com/', value: `https://www.ercot.com/static-assets/images/favicon.ico` },
  { key: 'www.ercot.com/', value: `/${img}/ercot.png` },
  { key: '66222186cb6456002879c292', value: `${img}/edf.svg` },
  {
    key: `5ef6072c5da42306c5087430`,
    value: `${img}/avantus.ico`,
  },
  {
    key: '607fe8e8925250001b6f8d43',
    value: `${img}/usbr.png`,
  },
  {
    key: `5ef607355da42306c50877c4`,
    value: `${img}/origis.svg`,
  },

  {
    key: `5ef607305da42306c50875fe`,
    value: `${src}www.equinor.com/`,
  },
  {
    key: `5ef607335da42306c50876e6`,
    value: `${src}invenergy.com/`,
  },
  {
    key: `5f18398d662cc60016018ce4`,
    value: `${src}www.bp.com/`,
  },
  {
    key: `5f8452b5dd7abd001646d1e6`,
    value: `https://www.keycaptureenergy.com/wp-content/uploads/2019/02/KCE-icon.png`,
  },
  {
    key: `609a8814f844f5001e6a8662`,
    value: `${src}www.angelenogroup.com/`,
  },
  {
    key: `60533f52435785001b5546e8`,
    value: `${src}www.doubleeagledevelopment.com`,
  },
]

export const ipp = [
  {
    key: `5f1b145333ddc60016e96139`,
    value: `${img}/terragen.png`,
  },

  {
    key: '611cef173d057a00246de454',
    value: 'https://totalenergies.com/themes/custom/totalenergies_com/dist/img/favicon.png',
  },

  { key: '5ef6072f5da42306c5087582', value: `${src}www.delawareriversolar.com/` },
  { key: '631ec2619295c0002390d868', value: `${src}www.adtsolar.com/` },
  { key: '60489d00e434f0001df58372', value: `${src}www.wm.com` },
  { key: '608ab3c2b49d4e001e87c04c', value: `${src}www.tesla.com` },
  { key: '60ec3a83635705001e64043d', value: `${src}www.archaeaenergy.com/` },
  { key: '5f1b31a18bfdce001703d350', value: `${src}www.solarliberty.com/` },
  {
    key: '5efcbb0b38ad960015e410ae',
    value: `https://static-assets.ny.gov/sites/all/themes/ny_gov/images/nygov-logo.png`,
  },
  { key: '63316daf387fc400213d8c6b', value: `${src}palmetto.com` },
  { key: '637ba2bff4d9a400213251f8', value: `${src}www.borregoenergy.com` },
  { key: '634942f742bafe002192b11b', value: `${src}www.hecategrid.com` },
  { key: '61b1fd020fb182001ed0b538', value: `${src}www.dominionenergy.com` },
  { key: '62b0361498d8f2001f35ec41', value: `${src}www.samsungcnt.com` },
  { key: '6240c22d431513001f0173c5', value: `${src}www.communityoffshorewind.com/` },
  {
    key: `60ee732bd03b63001fb6d2ab`,
    value: `${img}/eolian.png`,
  },
  {
    key: '63f35cc62da265002825b0db',
    value: `${src}www.enelnorthamerica.com/`,
  },
  {
    key: '6400a21febc5760029eb511b',
    value: `https://www.rwe.com/Favicons/favicon.ico`,
  },
  {
    key: `60cb8304129679001e45c147`,
    value: `${src}www.nexuspwr.com`,
  },
  {
    key: `60c1a8287b924b001e88b1f4`,
    value: `${src}www.californiaethanolpower.com`,
  },
  {
    key: `607994a9872436001ba17812`,
    value: `${src}newlook.dteenergy.com`,
  },
  {
    key: `608923899f35c4001bbef345`,
    value: `${src}www.onwardenergy.com`,
  },
  {
    key: `607fe819c691f8001ce6c507`,
    value: `${src}www.cbhydropower.org`,
  },
  {
    key: `60794ff6a086b8001ca35d62`,
    value: `${src}www.eh2power.com`,
  },
  {
    key: `5ef607335da42306c5087722`,
    value: `${src}www.lightsourcebp.com`,
  },
  {
    key: `5f63a0acd79a770016b2f357`,
    value: `${src}openmountainenergy.com`,
  },
  {
    key: `5f5f5d29be788e00169b561b`,
    value: `${src}www.solarparkenergy.com`,
  },
  {
    key: `5f244b93a4987a0015c28199`,
    value: `${src}envestcorp.com`,
  },
  {
    key: `5ef607385da42306c5087909`,
    value: `${src}www.tcenergy.com`,
  },
  {
    key: `5f52724b5048d200150b7871`,
    value: `${src}www.gpreinc.com`,
  },
  {
    key: `5ef607355da42306c50877d1`,
    value: `${src}www.pge.com`,
  },
  {
    key: `5f4575ca824cc10015ecf752`,
    value: `${src}www.arcadia.com`,
  },
  {
    key: `5f4417f7cd510c00153e9978`,
    value: `${src}santannaenergyservices.com`,
  },
  {
    key: `5f43ddeacd510c00153dc915`,
    value: `${src}www.consolenergy.com`,
  },
  {
    key: `5f35466f6b34570015989df0`,
    value: `${src}tericpower.com`,
  },
  {
    key: `5f1b3aab62db5e0015aeb313`,
    value: `${src}jpowerusa.com`,
  },
  {
    key: `5f2b0aec620ead00157209f7`,
    value: `${src}www.hitachiabb-powergrids.com`,
  },
  {
    key: `5ef607335da42306c50876e6`,
    value: `${src}invenergyllc.com`,
  },
  {
    key: `5f1b44d7705005001580477d`,
    value: `${src}www.middleriverpower.com`,
  },
  {
    key: `5f1b0e0f45c4be00156d2225`,
    value: `${src}www.mmpa.org`,
  },
  {
    key: `5fca7135080ac8001ce9508b`,
    value: `${src}www.luminant.com`,
  },
  {
    key: `5fc5158f5321ba001b6b306c`,
    value: `${src}www.steag.com`,
  },
  {
    key: `5fbc246c4de1db001c0f0ffd`,
    value: `${src}climeon.com`,
  },
  {
    key: `5fbbff6c0010e7001b9551a6`,
    value: `${src}www.erg.eu`,
  },
  {
    key: `5fb3d139ce73c2001f0cb247`,
    value: `${src}www.skysolarholdings.com`,
  },
  {
    key: `5fb377a4600cd6001b633feb`,
    value: `${src}www.abeienergy.com`,
  },
  {
    key: `5fac6080644ef60015010f37`,
    value: `${src}wcsbpower.com`,
  },
  {
    key: `5f1723bafdf69600158c9dd4`,
    value: `${src}www.shell.us`,
  },
  {
    key: `5f171c2d4156610015c1c22e`,
    value: `${src}longviewpower.com`,
  },
  {
    key: `5f15eaca0b85dd0015d18dc9`,
    value: `${src}www.bp.com`,
  },
  {
    key: `5ef607385da42306c50878fb`,
    value: `${src}www.taaleri.com`,
  },
  {
    key: `5ef607385da42306c508790b`,
    value: `${src}www.tenaska.com`,
  },
  {
    key: `5f1073626882ec0015aca5b0`,
    // value: `${src}www.cordeliopower.com`,
    value: `${img}/cordelio.svg`,
  },
  {
    key: `5f1070f7cbe230001727c8e0`,
    value: `${src}www.firstenergycorp.com`,
  },
  {
    key: `5ef607355da42306c50877ba`,
    value: `${src}www.opg.com`,
  },
  {
    key: `5ef607355da42306c50877d3`,
    value: `${src}www.pacificorp.com`,
  },
  {
    key: `5ef607355da42306c50877d9`,
    value: `${src}www.parkpower.com`,
  },
  {
    key: `5ef607365da42306c5087817`,
    value: `${src}www.pse.com`,
  },
  {
    key: `5ef607365da42306c5087819`,
    value: `${src}www.pureenergyus.com`,
  },
  {
    key: `5ef607345da42306c5087772`,
    value: `${src}www.nationalgridus.com`,
  },
  {
    key: `5ef607345da42306c508777c`,
    value: `${src}www.navisunllc.com`,
  },
  {
    key: `5ef607345da42306c5087780`,
    value: `${src}www.neoen.com`,
  },
  {
    key: `5ef607385da42306c50878f7`,
    value: `${src}switchenergypartners.com`,
  },
  {
    key: `5ef607365da42306c5087831`,
    value: `${src}www.renaissancepowerandgas.com`,
  },
  {
    key: `5ef607385da42306c50878ed`,
    value: `${src}www.gosunwave.com`,
  },
  {
    key: `5ef607345da42306c5087750`,
    value: `${src}www.mitsubishicorp.com`,
  },
  {
    key: `5ef607335da42306c5087736`,
    value: `${src}www.marubeni.com`,
  },
  {
    key: `5ef607365da42306c508784b`,
    value: `${src}www.eon.com`,
  },
  {
    key: `5ef6072c5da42306c5087450`,
    value: `${src}www.aep.com`,
  },
  {
    key: `5f0c89390cb4a200160b9160`,
    value: `${src}www.atlanticpower.com`,
  },
  {
    key: `5ef607335da42306c5087728`,
    value: `${src}www.clypg.com.cn`,
  },
  {
    key: `5ef607325da42306c50876b4`,
    value: `${src}hexagon-energy.com`,
  },
  {
    key: `5f08a7b554b38a001858d4c7`,
    value: `${src}www.capitalpower.com`,
  },
  {
    key: `5ef607325da42306c5087684`,
    value: `${src}www.gseps.com`,
  },
  {
    key: `5f08a5a1a624d700197a2bc8`,
    value: `${src}www.idacorpinc.com`,
  },
  {
    key: `5ef607315da42306c508764a`,
    value: `${src}www.genon.com`,
  },
  {
    key: `5ef607305da42306c50875fe`,
    value: `${src}www.equinor.com`,
  },
  {
    key: `5ef6072f5da42306c50875b4`,
    value: `${src}www.edfenergy.com`,
  },
  {
    key: `5ef6072f5da42306c50875a8`,
    value: `${src}www.eaglecreekre.com`,
  },
  {
    key: `5ef607335da42306c508770e`,
    value: `${src}www.kyuden-intl.co.jp`,
  },
  {
    key: `5ef6072f5da42306c5087596`,
    value: `${src}www.drax.com`,
  },
  {
    key: `5ef607395da42306c5087921`,
    value: `${src}www.total.com`,
  },
  {
    key: `5ef6072f5da42306c508757a`,
    value: `${src}www.daelimenergy.com`,
  },
  {
    key: `5ef6072f5da42306c508756e`,
    value: `${src}coronalenergy.com`,
  },
  {
    key: `5ef6072f5da42306c508756c`,
    value: `${src}www.corix.com`,
  },
  {
    key: `5ef6072f5da42306c508755e`,
    value: `${src}conradenergy.co.uk`,
  },
  {
    key: `5ef6072e5da42306c5087504`,
    value: `${src}www.cvegroup.com`,
  },
  {
    key: `5ef6072d5da42306c50874fa`,
    value: `${src}www.calpine.com`,
  },
  {
    key: `5ef6072d5da42306c50874f8`,
    value: `${src}calonenergy.com`,
  },
  {
    key: `5ef6072d5da42306c50874f4`,
    value: `${src}www.caithnessenergy.com`,
  },
  {
    key: `5ef607385da42306c5087911`,
    value: `${src}www.terraform.com`,
  },
  {
    key: `5ef607385da42306c5087905`,
    value: `${src}www.tateswood.com`,
  },
  {
    key: `5ef607385da42306c5087901`,
    value: `${src}www.talenenergy.com`,
  },
  {
    key: `5f0370e4da77100015ca7ed2`,
    value: `${src}www.amppartners.org`,
  },
  {
    key: `5fa440638022040015d6cadd`,
    value: `${src}www.southwestgen.com`,
  },
  {
    key: `5f9c56ff4baea80015f47190`,
    value: `${src}www.wtienergy.com`,
  },
  {
    key: `5ef607355da42306c50877b6`,
    value: `${src}www.olympuspower.com`,
  },
  {
    key: `5f92d9e70d7f5500168520f2`,
    value: `${src}www.lilliwaupfalls.com`,
  },
  {
    key: `5f8efd136005a70015b23a75`,
    value: `${src}alternusenergy.com`,
  },
  {
    key: `5f87596ea7ae7f0015a29848`,
    value: `${src}www.opc-energy.com`,
  },
  {
    key: `5f8743be9ebdad0015c5b85d`,
    value: `${src}www.suntechpowerdevelopment.com`,
  },
  {
    key: `5ef6072f5da42306c5087598`,
    value: `${src}newlook.dteenergy.com`,
  },
  {
    key: `5ef607375da42306c5087877`,
    value: `${src}www.7energy.com`,
  },
  {
    key: `5ef6072c5da42306c508745e`,
    value: `${src}www.agilonenergy.com`,
  },
  {
    key: `5ef6072c5da42306c508743e`,
    value: `${src}www.acenergy.com.ph`,
  },
  {
    key: `5efcbbbafec916001544c16b`,
    value: `${src}www.myavista.com`,
  },
  {
    key: `5efcb81e8122350017a9258f`,
    value: `${src}www.appalachianpower.com`,
  },
  {
    key: `60634edb2900b8001bede07f`,
    value: `${src}www.firstenergycorp.com`,
  },
  {
    key: `5fabe37a3e8f49001753150f`,
    value: `${src}www.firstenergycorp.com`,
  },
  {
    key: `60633f63d14fa7001eb785c4`,
    value: `${src}www.firstenergycorp.com`,
  },
  {
    key: `60489c67e434f0001df582c3`,
    value: `${src}www.fullcirclerenewables.com`,
  },
  {
    key: `60267ce6b098aa001b872043`,
    value: `${src}www.azurepower.com`,
  },
  {
    key: `60191677b21bd4001baa74ff`,
    value: `${src}mdvseia.org`,
  },
  {
    key: `5ef607375da42306c508787b`,
    value: `${src}www.shell.com`,
  },
  {
    key: `5fda5081f8bf51001e67c5a4`,
    value: `${src}www.skyglobalpartners.com`,
  },
  {
    key: `5f43d7c26ef93f00184fb650`,
    value: `${src}www.calpinesolutions.com`,
  },
  {
    key: `5fcf97fb9a97cf001bd7a4fc`,
    value: `${src}www.recgreenenergy.com`,
  },
  {
    key: `5f1aefbd530d560015a3356d`,
    value: `${src}www.atlanticpower.com`,
  },
  {
    key: `61125a6fa50fe4001edcf515`,
    value: `${src}www.jcmpower.ca`,
  },
  {
    key: `61125cbd926210001eaabd9b`,
    value: `${src}www.rwe.com`,
  },
  {
    key: `5f037046bc02e10015b4f931`,
    value: `${src}www.aep.com`,
  },
  {
    key: `611b9c272e500f0020a397ae`,
    value: `${src}osiyorenewables.us`,
  },
]

export const utilities = [
  {
    key: `60f7e707304fb20022e6e8f2`,
    value: `${src}www.lmud.org`,
  },
  {
    key: `60f09715869d4a001ed51649`,
    value: `${src}www.nipco.coop`,
  },
  {
    key: `60ee9cbe7af107001ef72acb`,
    value: `${src}www.dremc.com`,
  },
  {
    key: `5f171ad2edea6f001536bc82`,
    value: `${src}libertyutilities.com`,
  },
  {
    key: `60ed6b524b421e001e362d26`,
    value: `${src}libertyutilities.com`,
  },
  { key: `60b5ec65fe122e001e3c1ba0`, value: `${src}www.dnb.com` },
  {
    key: `60ec2d29d1426a001eae684a`,
    value: `${src}www.mwenergy.com`,
  },
  {
    key: `5f11b836e020790015874ff2`,
    value: `${src}www.basinelectric.com`,
  },
  {
    key: `60ec186511144b001e0be21f`,
    value: `${src}www.rcec.org`,
  },
  {
    key: `5f1b3ad162db5e0015aeb3f3`,
    value: `${src}www.wfec.com`,
  },
  {
    key: `60daa7a1d603fb001eb922d6`,
    value: `${src}www.energie360.ch`,
  },
  {
    key: `5f035e36b12b320015b90c25`,
    value: `${src}www.coned.com`,
  },
  {
    key: `60d176d2ed4ff3001e1ad86c`,
    value: `${src}www.peoplesgasdelivery.com`,
  },
  {
    key: `60cafc2c0aa802001e126b25`,
    value: `${src}ourpowermaine.org`,
  },
  {
    key: `60c74fc53e6c74001ef81836`,
    value: `${src}www.oremc.com`,
  },
  { key: `60c726277def50001e648fb8`, value: `${src}wgl.com` },
  {
    key: `605358ff6ba374001bf1491a`,
    value: `${src}www.mpower.org`,
  },
  {
    key: `60c1f01d7b924b001e893b67`,
    value: `${src}www.tclp.org`,
  },
  {
    key: `60bf591a9a29c6001ef1f7ba`,
    value: `${src}www.bloomberg.com`,
  },
  {
    key: `60b0888afbf706001e5bd36a`,
    value: `${src}www.craigheadelectric.coop`,
  },
  {
    key: `60b084d5b9fb0f001e877e15`,
    value: `${src}www.jonesborocwl.org`,
  },
  {
    key: `60af84938c0b380021a3a643`,
    value: `${src}www.nimeca.com`,
  },
  {
    key: `60ae64b26e4852001e335631`,
    value: `${src}www.dcwater.com`,
  },
  {
    key: `60ae5d83e6d2de001e190658`,
    value: `${src}www.hudsonvalleycommunitypower.com`,
  },
  {
    key: `60a79b18890241001ec42049`,
    value: `${src}www.nationalgrid.com`,
  },
  { key: `60a4f46e9ecb9b001b06ca9a`, value: `${src}cvecinc.org` },
  { key: `5f183e7ce10e540015efac0f`, value: `${src}dgc-us.com` },
  { key: `609e91e9e85f2c001bcebc96`, value: `${src}www.dnb.com` },
  {
    key: `5f7dcd75d4d9d300179696ee`,
    value: `${src}www.pepco.com`,
  },
  {
    key: `609b8ad3f0cb54001b8edccd`,
    value: `${src}www.como.gov`,
  },
  { key: `604fbdef418971001bbcbce7`, value: `${src}undefined` },
  {
    key: `5f17267b5b91770015a27c14`,
    value: `${src}www.smeco.coop`,
  },
  { key: `608bcf6dc48fd2001bcf69ec`, value: `${src}nrco.coop` },
  {
    key: `5fce78fc4281ce0020434443`,
    value: `${src}www.oppd.com`,
  },
  {
    key: `608a84d801c005001cf2e068`,
    value: `${src}www.starkvilleutilities.com`,
  },
  { key: `5fa9ddf2507ccc0016c27e2a`, value: `${src}www.kub.org` },
  {
    key: `60507464b853e70021be73ff`,
    value: `${src}www.entergy-texas.com`,
  },
  {
    key: `5f0362e3c6769500159ad5e8`,
    value: `${src}www.entergy.com`,
  },
  {
    key: `5f184ae4e10e540015efafc2`,
    value: `${src}www.entergy-neworleans.com`,
  },
  {
    key: `5f15f5b90b85dd0015d1c82d`,
    value: `${src}www.entergy-mississippi.com`,
  },
  {
    key: `5f19d1a65a3eca00153ba269`,
    value: `${src}www.entergy-louisiana.com`,
  },
  {
    key: `5ef607305da42306c50875e4`,
    value: `${src}www.entergy-arkansas.com`,
  },
  {
    key: `6089232c39fec9001b7ab59b`,
    value: `${src}www.abcwua.org`,
  },
  { key: `6087b1c32ee278001b2d0cdb`, value: `${src}pvrea.coop` },
  { key: `607fe0adb66218001eae6e62`, value: `${src}klpd.org` },
  {
    key: `607d8b980d9c7a001b4fd32f`,
    value: `${src}www.choptankelectric.coop`,
  },
  {
    key: `60794f89a086b8001ca35cdb`,
    value: `${src}www.newpointgas.com`,
  },
  {
    key: `60794f39b731f8001bf1d0d2`,
    value: `${src}brooksenergycompany.com`,
  },
  {
    key: `6076f2a9f92706001b783fd8`,
    value: `${src}www.eea.coop`,
  },
  {
    key: `6075858220a030001b0320dd`,
    value: `${src}vermontelectric.coop`,
  },
  {
    key: `6073ff7ea4f100001b17587a`,
    value: `${src}sprucepower.com`,
  },
  {
    key: `6073ef43a4f100001b173aed`,
    value: `${src}neighborhoodpower.com`,
  },
  {
    key: `606db1987f8754001c40bed9`,
    value: `${src}www.blueridgeenergy.com`,
  },
  {
    key: `606c455f715dae0021b9e9ea`,
    value: `${src}www.myavista.com`,
  },
  {
    key: `606ad2bfdb6acd001c61a986`,
    value: `${src}www.mass.gov`,
  },
  {
    key: `6064a4f83d76fb001b0a92cb`,
    value: `${src}www.duquesnelight.com`,
  },
  {
    key: `606483cce3f234001bc8858e`,
    value: `${src}www.peco.com`,
  },
  {
    key: `5ef607315da42306c5087610`,
    value: `${src}www.exeloncorp.com`,
  },
  {
    key: `5f401315d7043f0016e5988f`,
    value: `${src}www.itc-holdings.com`,
  },
  {
    key: `606470541cb401001ce38405`,
    value: `${src}www.itc-holdings.com`,
  },
  {
    key: `5f7cb04dbda34c0015bd9da1`,
    value: `${src}www.hydro.mb.ca`,
  },
  {
    key: `5f7c54069c824a0015966334`,
    value: `${src}www.holycross.com`,
  },
  {
    key: `5f7bde343b602000159fdc5c`,
    value: `${src}www.puc.texas.gov`,
  },
  {
    key: `5f7bd9e2979f190016945a6b`,
    value: `${src}yukonenergy.ca`,
  },
  {
    key: `5efcbd4f36f87e001522adda`,
    value: `${src}www.ladwp.com`,
  },
  {
    key: `5f7b5371fb2f8b0018ae24ea`,
    value: `${src}www.loudonutilities.org`,
  },
  {
    key: `5ef6072f5da42306c5087584`,
    value: `${src}www.delmarva.com`,
  },
  {
    key: `5f15967440fc9b0015e4abd6`,
    value: `${src}algonquinpower.com`,
  },
  { key: `5f778112907b3200180f2315`, value: `${src}www.bge.com` },
  {
    key: `5f7766f7fd5e710015d11d75`,
    value: `${src}www.provwater.com`,
  },
  {
    key: `5f7332cf0953e80015db2c53`,
    value: `${src}www.cvea.org`,
  },
  {
    key: `5f6c6639a466be0015d51591`,
    value: `${src}www.amea.com`,
  },
  { key: `5f64990003b8b60019c2bcb2`, value: `${src}www.csu.org` },
  {
    key: `5f636b41a440c70015974d41`,
    value: `${src}www.ncpa.com`,
  },
  { key: `5f0f670013ce030016552490`, value: `${src}www.sce.com` },
  {
    key: `5f620849d33ff1001527ba34`,
    value: `${src}www.cipco.net`,
  },
  {
    key: `5ef607325da42306c508769e`,
    value: `${src}www.hawaiianelectric.com`,
  },
  {
    key: `5f5a2a115f6b470016143660`,
    value: `${src}www.sayreville.com`,
  },
  {
    key: `5f58c4f647c50d00152ddd1c`,
    value: `${src}www.sjindustries.com`,
  },
  { key: `5f58d9f46c99f30015e182b3`, value: `${src}www.wmp.com` },
  {
    key: `5f57ca35be60b0001850ad2b`,
    value: `${src}www.midamericanenergyservices.com`,
  },
  {
    key: `5f52943edbeb8e00157200fe`,
    value: `${src}www.gsec.coop`,
  },
  { key: `5f0c8ee2ff4dd7001529e533`, value: `${src}www.oge.com` },
  {
    key: `5f4fec5ae6b50b0016098967`,
    value: `${src}www.homerelectric.com`,
  },
  {
    key: `5f4fec05039bb0001597b478`,
    value: `${src}www.mea.coop`,
  },
  {
    key: `5f4fea676a3253001509bef5`,
    value: `${src}www.mlandp.com`,
  },
  {
    key: `5f4fe93706375700154dadaf`,
    value: `${src}www.chugachelectric.com`,
  },
  {
    key: `5f4fe51fa8b7620015a08533`,
    value: `${src}www.brightridge.com`,
  },
  { key: `5f4577f941d5ac0015bcd6b9`, value: `${src}aeepr.com` },
  {
    key: `5f4fcb427dd26800157fef63`,
    value: `${src}www.sparkenergy.com`,
  },
  {
    key: `5f4e5eece645880018a2a2ef`,
    value: `${src}www.prpa.org`,
  },
  {
    key: `5f47fcd55f11380015cf417e`,
    value: `${src}www.atlanticcityelectric.com`,
  },
  {
    key: `5ef607335da42306c5087706`,
    value: `${src}home.kepco.co.kr`,
  },
  {
    key: `5f4577286c6a31001546e202`,
    value: `${src}pioneercommunityenergy.ca.gov`,
  },
  {
    key: `5f441be40192a30015634044`,
    value: `${src}www.swgas.com`,
  },
  {
    key: `5f4418dbcd510c00153e9b95`,
    value: `${src}www.santeecooper.com`,
  },
  {
    key: `5f43e85ccd510c00153de77b`,
    value: `${src}www.hudsonenergy.net`,
  },
  {
    key: `5f1afda245c4be00156cbc05`,
    value: `${src}www.sdge.com`,
  },
  {
    key: `5f43cb812260e70015301fda`,
    value: `${src}www.palmerenergy.com`,
  },
  {
    key: `5f15f0b30780e100153f3eca`,
    value: `${src}www.comed.com`,
  },
  {
    key: `5f3fce323f86ef001512e56e`,
    value: `${src}www.shake-energy.com`,
  },
  {
    key: `5ef607345da42306c508777e`,
    value: `${src}www.nppd.com`,
  },
  {
    key: `5f3e88e9632c2c0015a8a9f5`,
    value: `${src}www.mlgw.com`,
  },
  { key: `5f3d2756a0f2a6001566f876`, value: `${src}www.txu.com` },
  { key: `5ef607385da42306c508790d`, value: `${src}www.tva.com` },
  {
    key: `5f3c04da5843210015fed528`,
    value: `${src}www.energy-northwest.com`,
  },
  {
    key: `5f3ad5e2411b080015b40fa9`,
    value: `${src}broadreachpower.com`,
  },
  {
    key: `5f3ac7eb2cfbcb001704b524`,
    value: `${src}www.hamiltonucorp.com`,
  },
  {
    key: `5f36a6dcb0553c00159c12f5`,
    value: `${src}cpowerenergymanagement.com`,
  },
  {
    key: `5f36a1bf7a896d00157602d9`,
    value: `${src}www.bullfrogpower.com`,
  },
  {
    key: `5f3573e9ea10cc00158d2539`,
    value: `${src}goodenergy.com`,
  },
  {
    key: `5f357280834ad000157fbd59`,
    value: `${src}www.transalta.com`,
  },
  {
    key: `5f3552f9c4d58f00172d3447`,
    value: `${src}www.myrec.coop`,
  },
  {
    key: `5f3552ac1aa9f10015dcd0dc`,
    value: `${src}www.svec.coop`,
  },
  {
    key: `5f353f300a19700016daddd0`,
    value: `${src}www.vectren.com`,
  },
  {
    key: `5f344eeb0b285f001571b125`,
    value: `${src}www.cmsenergy.com`,
  },
  {
    key: `5f32fc9dc36d3e0015660561`,
    value: `${src}www.lbwl.com`,
  },
  {
    key: `5f33fbd10b285f0015704aa8`,
    value: `${src}www.mississippipower.com`,
  },
  {
    key: `5f3182a7833a4e00152158f4`,
    value: `${src}www.versantpower.com`,
  },
  {
    key: `5f3179817c63820015efd533`,
    value: `${src}www.brkenergy.com`,
  },
  {
    key: `5f316b974a77c90015b97825`,
    value: `${src}www.thecleanenergyalliance.org`,
  },
  {
    key: `5ef6072f5da42306c50875a4`,
    value: `${src}www.dynegy.com`,
  },
  {
    key: `5f2afc0e94b66f00157e028a`,
    value: `${src}www.kepco.co.jp`,
  },
  {
    key: `5f29a857499f7e0018e83d7a`,
    value: `${src}www.hydroquebec.com`,
  },
  {
    key: `5f29a16577bbc90018a86af6`,
    value: `${src}jobs.pseg.com`,
  },
  {
    key: `5f297bc7a050d70015eec73a`,
    value: `${src}www.astralenergyllc.com`,
  },
  {
    key: `5f285db36fef0000155a6fe3`,
    value: `${src}www.ecsc.org`,
  },
  {
    key: `5f2473c489268d00150f02f4`,
    value: `${src}portagepower.com`,
  },
  {
    key: `5f246f3e590a5b0016e6df7e`,
    value: `${src}www.enmax.com`,
  },
  {
    key: `5f243cb2cbd97f00158fc141`,
    value: `${src}sanjosecleanenergy.org`,
  },
  {
    key: `5f243bfb2b0f9700172895f4`,
    value: `${src}www.peninsulacleanenergy.com`,
  },
  {
    key: `5f2435b4e5d9410015cea6c8`,
    value: `${src}www.cpsenergy.com`,
  },
  {
    key: `5f2315258600500015f604a3`,
    value: `${src}www.cmua.org`,
  },
  {
    key: `5f22e703cb22e20015a40e93`,
    value: `${src}www.cityutilities.net`,
  },
  {
    key: `5f21c24dfddbcc0015d95786`,
    value: `${src}www.cbpower.coop`,
  },
  {
    key: `5f2023d8c9b19500152a9b28`,
    value: `${src}www.dairylandpower.com`,
  },
  {
    key: `5f1f3fa55a45ec0015fcd476`,
    value: `${src}austinenergy.com`,
  },
  { key: `5f1f33b06395440015eeb395`, value: `${src}lge-ku.com` },
  {
    key: `5f1efc6fc1c0da0015d80375`,
    value: `${src}www.atcllc.com`,
  },
  {
    key: `5f1b49f58899030015556dd0`,
    value: `${src}northeasttexaselectric.com`,
  },
  {
    key: `5f1b4943dbef120015d8ec3c`,
    value: `${src}www.montana-dakota.com`,
  },
  {
    key: `5f1b3c4b7ee03c0015487a54`,
    value: `${src}www.transwestexpress.net`,
  },
  {
    key: `5f1b2cf962db5e0015ae56f0`,
    value: `${src}www.silvercreekog.com`,
  },
  {
    key: `5f1b151397b5380015c30c33`,
    value: `${src}www.transourceenergy.com`,
  },
  {
    key: `5f1b17491c3f6300150f8820`,
    value: `${src}accel.wisconsinpublicservice.com`,
  },
  {
    key: `5f1b11502b82b6001516dfd8`,
    value: `${src}www.ozarksecc.com`,
  },
  {
    key: `5f1b110f64470e0015cb0714`,
    value: `${src}www.siliconvalleypower.com`,
  },
  { key: `5fce67abf5935f001b0f9f3b`, value: `${src}wbmlp.org` },
  { key: `5fce35dcb6020e001b69635e`, value: `${src}www.lus.org` },
  {
    key: `5fca8f36cb148f001c5e48f5`,
    value: `${src}www.energyonline.co.nz`,
  },
  {
    key: `5fca5e6057b944001c6b981f`,
    value: `${src}www.lpandl.com`,
  },
  {
    key: `5fca0d5d35ce40001ba4abd6`,
    value: `${src}www.galp.com`,
  },
  {
    key: `5fca0691e91f82001db9f16a`,
    value: `${src}www.harrisonburgelectric.com`,
  },
  { key: `5fc927922ab53f001b696b4f`, value: `${src}aecc.com` },
  { key: `5fc8ecfe01d2d3001cac978d`, value: `${src}www.jsw.in` },
  {
    key: `5fc8e924e59e0f001db3ae8c`,
    value: `${src}www.tatapower.com`,
  },
  {
    key: `5fc8e8fb061fd9001b3d78f7`,
    value: `${src}www.torrentpower.com`,
  },
  {
    key: `5fc8d7097b268b001c5985fc`,
    value: `${src}www.britishgas.co.uk`,
  },
  { key: `5fc8b2e6061fd9001b3d151c`, value: `${src}undefined` },
  {
    key: `5fc7fe52e7b220001bda61fa`,
    value: `${src}www.demecinc.net`,
  },
  {
    key: `5f1af3be2ef52f001545f8a7`,
    value: `${src}www.pacificpud.org`,
  },
  {
    key: `5f47b5941a40640015494f09`,
    value: `${src}www.xcelenergy.com`,
  },
  {
    key: `5f1b392a8ae0870015f31386`,
    value: `${src}www.seattle.gov`,
  },
  {
    key: `5fc7a886265563001cc1bfdf`,
    value: `${src}www.blackhillscorp.com`,
  },
  {
    key: `5fc79b682e8580001bc873de`,
    value: `${src}www.mwra.com`,
  },
  {
    key: `5fc78e3d052da2001cc8ad63`,
    value: `${src}www.turn.org`,
  },
  {
    key: `5fc631f452e60a001b1a5ccb`,
    value: `${src}narrabay.com`,
  },
  {
    key: `5fc608b59855c7001b675628`,
    value: `${src}www.imea.org`,
  },
  {
    key: `5fc5584909f351001b36f73a`,
    value: `${src}www.holaluz.com`,
  },
  {
    key: `5fc1196bee707a001b7f4039`,
    value: `${src}www.parisbpu.com`,
  },
  {
    key: `5fbd0f42edeeea001b485cb0`,
    value: `${src}www.horizonpower.com.au`,
  },
  {
    key: `5fbd079795c905001b5fb6ed`,
    value: `${src}legendpower.com`,
  },
  {
    key: `5fbcf7b5303e4f001d39e402`,
    value: `${src}outsourceucc.com`,
  },
  { key: `5fbc133dd074c6001bea564d`, value: `${src}www.les.com` },
  {
    key: `5fbc10332b23fb001d349555`,
    value: `${src}www.gulfpower.com`,
  },
  {
    key: `5fbb825e98cdbf001cd97e3e`,
    value: `${src}allproelectric.com`,
  },
  {
    key: `5fbb732dadf219001bf8cafd`,
    value: `${src}www.diversepower.com`,
  },
  {
    key: `5fbb6ab9adf219001bf8c482`,
    value: `${src}www.fortisbc.com`,
  },
  {
    key: `5fb7be39f8639e001c99da5a`,
    value: `${src}www.centralelectriccompany.com`,
  },
  {
    key: `5fb7b90404f91c001b699d0e`,
    value: `${src}www.musfiber.net`,
  },
  {
    key: `5fb7b2f7e30a83001ce48400`,
    value: `${src}www.phoenixenergygroup.com`,
  },
  {
    key: `5fb641e58a5a53001b476680`,
    value: `${src}www.vicinityenergy.us`,
  },
  {
    key: `5fb59188291ef0001b44d94b`,
    value: `${src}www.beld.net`,
  },
  {
    key: `5fb52e9a2212b7001b0d5d8e`,
    value: `${src}www.cityofanderson.com`,
  },
  {
    key: `5fb524ec549446001daf1a89`,
    value: `${src}www.cityutilities.net`,
  },
  {
    key: `5fb4a0700be67f001bde8e45`,
    value: `${src}www.stratosfuel.com`,
  },
  {
    key: `5fb3dacf1e6631001b391fe9`,
    value: `${src}utahenergy.org`,
  },
  { key: `5fb3d0d1b764e1001ff60be8`, value: `${src}skrecc.com` },
  {
    key: `5fb3b5bc07b5c7001ba553cf`,
    value: `${src}www.portlandsenergycentre.com`,
  },
  { key: `5fb3aac7b76fc0001bfc1292`, value: `${src}opc.com` },
  {
    key: `5fb3a50840eec90021abbd7f`,
    value: `${src}www.npandl.com`,
  },
  {
    key: `5fb3984af88c97001b59c484`,
    value: `${src}maenergy.co.uk`,
  },
  { key: `5fb397a9216723001f339278`, value: `${src}longsol.com` },
  {
    key: `5fb3927140eec90021abab5a`,
    value: `${src}hydroottawa.com`,
  },
  {
    key: `5fb3827a216723001f337e32`,
    value: `${src}daylightsavings.us`,
  },
  {
    key: `5fae8b6a82e91a0015c73883`,
    value: `${src}www.brucepower.com`,
  },
  {
    key: `5fae73132816bf00177bf3dd`,
    value: `${src}www.mclainelectric.com`,
  },
  {
    key: `5fae664ecf20a2001513a70c`,
    value: `${src}newwaveenergy.com`,
  },
  { key: `5fae6480bfd3e50016de920d`, value: `${src}getgex.com` },
  {
    key: `5fae57809dba040015950354`,
    value: `${src}www.ekpc.coop`,
  },
  {
    key: `5fad367bf4de9f00163424b5`,
    value: `${src}www.cepci.org`,
  },
  { key: `5fad3374d950380016dffcf1`, value: `${src}seelllc.com` },
  {
    key: `5fad3264c860f60015fdeb1a`,
    value: `${src}www.grantpud.org`,
  },
  {
    key: `5fad2a60d950380016dfedbd`,
    value: `${src}www.sunflower.net`,
  },
  { key: `5f7c48249c824a0015965313`, value: `${src}www.aps.com` },
  {
    key: `5fac0646b46aaf0018ff823b`,
    value: `${src}getgpower.com`,
  },
  {
    key: `5fabe41ce6151600157caddc`,
    value: `${src}providerpower.com`,
  },
  {
    key: `5f917dbdcf15c9001612484f`,
    value: `${src}sustainablewestchester.org`,
  },
  {
    key: `5ef6072b5da42306c5087424`,
    value: `${src}www.tfcutilities.com`,
  },
  {
    key: `5faa705fd665420015086e2f`,
    value: `${src}www.psoklahoma.com`,
  },
  {
    key: `5faa6894f892e20015aba5c5`,
    value: `${src}www.sipower.org`,
  },
  {
    key: `5f1b0bf16166c5001686132d`,
    value: `${src}www.libertypowercorp.com`,
  },
  {
    key: `5f1aff236166c5001685e4b5`,
    value: `${src}www.nvenergy.com`,
  },
  {
    key: `5f1af49031b12800157141bc`,
    value: `${src}www.lipower.org`,
  },
  {
    key: `5f19ed82d22d4700154582f1`,
    value: `${src}www.midamericanenergy.com`,
  },
  {
    key: `5f1aebe431b12800157116f7`,
    value: `${src}www.odec.com`,
  },
  {
    key: `5f19e14875f51600164a9c45`,
    value: `${src}www.ilec.coop`,
  },
  {
    key: `5f19e0cd75f51600164a9a60`,
    value: `${src}www.alliantenergy.com`,
  },
  { key: `5f19dfd2d22d4700154544c5`, value: `${src}irea.coop` },
  {
    key: `5f19de90d019630015dffbdc`,
    value: `${src}www.e-co-op.com`,
  },
  {
    key: `5f19d9c95a3eca00153bd798`,
    value: `${src}www.hea.coop`,
  },
  {
    key: `5f18a268d9315f0015f532b0`,
    value: `${src}www.jonesborocwl.org`,
  },
  {
    key: `5f199a28b284410015d6fbc7`,
    value: `${src}www.acornenergycoop.com`,
  },
  {
    key: `5f18914f1def0900173eeedf`,
    value: `${src}greatriverenergy.com`,
  },
  {
    key: `5f1754b9fdf69600158db6be`,
    value: `${src}www.aeci.org`,
  },
  {
    key: `5f17433ffdf69600158d5747`,
    value: `${src}www.xcelenergy.com`,
  },
  {
    key: `5ef6073c5da42306c5087985`,
    value: `${src}www.xcelenergy.com`,
  },
  {
    key: `5f173e8a5b91770015a31d22`,
    value: `${src}www.we-energies.com`,
  },
  {
    key: `5f173b2e2e5141001553b549`,
    value: `${src}www.we-energies.com`,
  },
  { key: `5f1733b82e514100155387ba`, value: `${src}unitil.com` },
  {
    key: `5f1722c96b426e0015a8688c`,
    value: `${src}www.rockymountainpower.net`,
  },
  {
    key: `5f171f4cfdf69600158c85a9`,
    value: `${src}www.nipsco.com`,
  },
  {
    key: `5f1719b2bf985b00155928cd`,
    value: `${src}kitcarson.com`,
  },
  {
    key: `5f170e02a08bfe0017102113`,
    value: `${src}www.impa.com`,
  },
  {
    key: `5f170a8fdf67020015a9a58c`,
    value: `${src}www.hmpl.com`,
  },
  {
    key: `5f15f3a217efaf00153fff9d`,
    value: `${src}www.etec.coop`,
  },
  {
    key: `5f15eec633fbdb00159ed01b`,
    value: `${src}www.cowlitzpud.org`,
  },
  {
    key: `5f15edf0df06b80017e69a75`,
    value: `${src}www.capitalpower.com`,
  },
  {
    key: `5f15e73e989d9800154d40b4`,
    value: `${src}www.ameren.com`,
  },
  {
    key: `5f15c416d2b5640015d1f29b`,
    value: `${src}www.ameren.com`,
  },
  {
    key: `5f15a17fa3438a00179535f9`,
    value: `${src}www.bvua.com`,
  },
  { key: `5ef6072d5da42306c50874ce`, value: `${src}www.tep.com` },
  {
    key: `5f10511a8f338f001580cb0a`,
    value: `${src}www.mbcommunitypower.org`,
  },
  {
    key: `5ef6073b5da42306c5087979`,
    value: `${src}www.evergy.com`,
  },
  {
    key: `5f11be95e02079001587666b`,
    value: `${src}www.smud.org`,
  },
  {
    key: `5f11bd8c9764e10015ef543b`,
    value: `${src}www.conwaycorp.com`,
  },
  {
    key: `5f11ba019764e10015ef4790`,
    value: `${src}www.alabamapower.com`,
  },
  {
    key: `5f11b9852cc45c0015bf4472`,
    value: `${src}www.powersouth.com`,
  },
  {
    key: `5f11b8c90809090015d39c89`,
    value: `${src}www.bigrivers.com`,
  },
  { key: `5f11a9999764e10015eee82e`, value: `${src}www.fpl.com` },
  {
    key: `5f10bea9b7841e0015c17a55`,
    value: `${src}www.saskpower.com`,
  },
  { key: `5f10bc90f1006200175294b6`, value: `${src}fmpa.com` },
  {
    key: `5f10b175f10062001752579e`,
    value: `${src}www.georgiapower.com`,
  },
  { key: `5f10a7e8d5c6f500156de655`, value: `${src}www.rge.com` },
  {
    key: `5f10a7abff41470016c6451d`,
    value: `${src}www.nyseg.com`,
  },
  {
    key: `5f109c317799780015da01fd`,
    value: `${src}www.dmea.com`,
  },
  { key: `5f107ca3d5c6f500156cf7f3`, value: `${src}www.mge.com` },
  {
    key: `5f10798c6882ec0015acd2b2`,
    value: `${src}www.northwesternenergy.com`,
  },
  {
    key: `5f10700aff41470016c55821`,
    value: `${src}www.srpnet.com`,
  },
  {
    key: `5ef607355da42306c50877cd`,
    value: `${src}www.otpco.com`,
  },
  {
    key: `5ef607345da42306c508774a`,
    value: `${src}www.mnpower.com`,
  },
  {
    key: `5ef607335da42306c5087730`,
    value: `${src}majorenergy.com`,
  },
  {
    key: `5f0c87390cb4a200160b8927`,
    value: `${src}www.pplweb.com`,
  },
  {
    key: `5f0c84d81468d00015a2362b`,
    value: `${src}www.wecenergygroup.com`,
  },
  {
    key: `5f0c8296ff4dd70015299ee4`,
    value: `${src}www.blackhillscorp.com`,
  },
  {
    key: `5f08c82c7d54740015c4ab14`,
    value: `${src}www.sempra.com`,
  },
  {
    key: `5f08b3a79072b40015a6f646`,
    value: `${src}www.pnmresources.com`,
  },
  {
    key: `5f089a9b65238a00155c243f`,
    value: `${src}www.edison.com`,
  },
  {
    key: `5ef607305da42306c5087600`,
    value: `${src}www.eweb.org`,
  },
  {
    key: `5ef607305da42306c50875fc`,
    value: `${src}www.epholding.cz`,
  },
  {
    key: `5ef607305da42306c50875f6`,
    value: `${src}www.eonenergy.com`,
  },
  {
    key: `5ef607305da42306c50875ee`,
    value: `${src}www.entrustenergy.com`,
  },
  {
    key: `5ef607305da42306c50875d4`,
    value: `${src}www.energir.com`,
  },
  {
    key: `5ef607305da42306c50875c0`,
    value: `${src}www.eligoenergy.com`,
  },
  {
    key: `5ef607305da42306c50875ba`,
    value: `${src}www.epelectric.com`,
  },
  {
    key: `5ef6072f5da42306c508759e`,
    value: `${src}www.duke-energy.com`,
  },
  {
    key: `5ef607335da42306c5087712`,
    value: `${src}lakeviewlight.com`,
  },
  {
    key: `5ef607335da42306c5087702`,
    value: `${src}www.klickitatpud.com`,
  },
  {
    key: `5ef607335da42306c50876f6`,
    value: `${src}joscoenergy.com`,
  },
  {
    key: `5ef607335da42306c50876ec`,
    value: `${src}www.itc-holdings.com`,
  },
  {
    key: `5ef607325da42306c50876ce`,
    value: `${src}www.indianamichiganpower.com`,
  },
  {
    key: `5ef607315da42306c508760a`,
    value: `${src}www.eversource.com`,
  },
  {
    key: `5f071742c06c470015b7109d`,
    value: `${src}www.fortisinc.com`,
  },
  {
    key: `5ef6073c5da42306c508798d`,
    value: `${src}xoomenergy.com`,
  },
  {
    key: `5ef6073a5da42306c508796b`,
    value: `${src}vistaenergymarketing.com`,
  },
  {
    key: `5ef607395da42306c508795d`,
    value: `${src}www.verdeenergy.com`,
  },
  {
    key: `5f060291aad6e70015442888`,
    value: `${src}www.southerncompany.com`,
  },
  {
    key: `5f05fe93d157da0016c5cdad`,
    value: `${src}www.vistracorp.com`,
  },
  {
    key: `5ef6072f5da42306c508758e`,
    value: `${src}www.directenergy.com`,
  },
  {
    key: `5ef6072f5da42306c508758c`,
    value: `${src}diamondenergy.com.au`,
  },
  { key: `5f05e29baad6e700154343bc`, value: `${src}www.pnm.com` },
  {
    key: `5ef607395da42306c5087919`,
    value: `${src}www.uinet.com`,
  },
  {
    key: `5f04b47d15f39800157c759b`,
    value: `${src}www.idacorpinc.com`,
  },
  {
    key: `5ef6072f5da42306c5087562`,
    value: `${src}www.consumersenergy.com`,
  },
  {
    key: `5ef6072f5da42306c5087560`,
    value: `${src}www.constellation.com`,
  },
  {
    key: `5ef6072e5da42306c5087532`,
    value: `${src}www.citizensenergygroup.com`,
  },
  {
    key: `5ef6072e5da42306c5087526`,
    value: `${src}chariotenergy.com`,
  },
  {
    key: `5ef6072e5da42306c5087518`,
    value: `${src}www.mycvec.com`,
  },
  {
    key: `5f047c8191d5aa0015dc6e42`,
    value: `${src}www.centerpointenergy.com`,
  },
  {
    key: `5ef607385da42306c5087903`,
    value: `${src}www.tampaelectric.com`,
  },
  {
    key: `5f036f48f8ae7d0016835115`,
    value: `${src}www.ameren.com`,
  },
  {
    key: `5ef6072f5da42306c5087592`,
    value: `${src}www.dominionenergy.com`,
  },
  {
    key: `5ef607385da42306c50878d3`,
    value: `${src}mystream.com`,
  },
  {
    key: `5f3fea730f911f0017e7aef7`,
    value: `${src}cleanpoweralliance.org`,
  },
  {
    key: `5fa599eeb027160015460ba6`,
    value: `${src}cooperativeenergy.com`,
  },
  {
    key: `5fa56832feb1560016507a39`,
    value: `${src}www.mrenergy.com`,
  },
  {
    key: `5fa55ca12b7a9b0015c83d3e`,
    value: `${src}www.erthpower.com`,
  },
  {
    key: `5fa432c6fef39a0015ff3761`,
    value: `${src}www.peoplesgasdelivery.com`,
  },
  { key: `5fa2e0e24aade0001542f5c7`, value: `${src}www.jea.com` },
  { key: `5fa074e47ccec80015e2b91e`, value: `${src}glps.net` },
  {
    key: `5fa05fb059c06e0015d25beb`,
    value: `${src}www.pec.coop`,
  },
  { key: `5fa0593bec76aa0015139bb7`, value: `${src}www.hei.com` },
  {
    key: `5f9c6c74e3189f001769880a`,
    value: `${src}www.sanpatricioelectric.org`,
  },
  {
    key: `5f9c553b8edb1c001553af5f`,
    value: `${src}www.emtbg.com`,
  },
  {
    key: `5f9c5425fddd5500152bc6be`,
    value: `${src}www.heritagepower.com`,
  },
  { key: `5f9c30de5ba7d70016951ae6`, value: `${src}ebce.org` },
  {
    key: `5f9adfe1d2bafe00152d2a95`,
    value: `${src}hearstpower.com`,
  },
  { key: `5f9ad8daf46bb30016f54851`, value: `${src}hotec.coop` },
  {
    key: `5f99da33df13920015d1215e`,
    value: `${src}www.infuseenergy.com`,
  },
  {
    key: `5f99d486050c0700151fd621`,
    value: `${src}www.lselectric.co.kr`,
  },
  { key: `5f99d22549e9de001521b4e1`, value: `${src}mwdh2o.com` },
  {
    key: `5f998912df13920015d0b2f2`,
    value: `${src}www.gexaenergy.com`,
  },
  {
    key: `5f986ab750c37c0015bf529a`,
    value: `${src}www.lpea.coop`,
  },
  {
    key: `5f985b6214128600152339a6`,
    value: `${src}danvilleutilities.com`,
  },
  {
    key: `5f981baebabf380015007476`,
    value: `${src}www.tecoenergy.com`,
  },
  {
    key: `5f9818639fa8fe001565f14d`,
    value: `${src}www.rmld.com`,
  },
  {
    key: `5f9811a49adad70015a0367b`,
    value: `${src}www.cityofpaloalto.org`,
  },
  {
    key: `5f977a7a118f880015f60656`,
    value: `${src}www.brazoselectric.com`,
  },
  {
    key: `5f9777965007a90015836b02`,
    value: `${src}www.coserv.com`,
  },
  {
    key: `5f5b8f9d8e3b960016e2169e`,
    value: `${src}3cenergy.org`,
  },
  {
    key: `5f970b474539c3001721ee80`,
    value: `${src}www.conservice.com`,
  },
  {
    key: `5f92ed7b59f0200015a72762`,
    value: `${src}www.bentonpud.org`,
  },
  {
    key: `5f91e1639ac4ed00163ca062`,
    value: `${src}www.websterec.com`,
  },
  {
    key: `5f9191cc86c8da0015886377`,
    value: `${src}www.nhec.com`,
  },
  {
    key: `5f9190845794e300152094e8`,
    value: `${src}sourcepowerco.com`,
  },
  {
    key: `5f918a5f0be3fa001682008f`,
    value: `${src}sonomacleanpower.org`,
  },
  {
    key: `5f914cad690fd3001572085f`,
    value: `${src}www.firstpointpower.com`,
  },
  {
    key: `5f90aa95f0cb460015248a0a`,
    value: `${src}www.buttechoiceenergy.org`,
  },
  {
    key: `5f8f21459e2ead0015ea4b29`,
    value: `${src}www.duke-energy.com`,
  },
  {
    key: `5f8f1e8b7ded1d0017c1e066`,
    value: `${src}www.monroecommunitypower.com`,
  },
  {
    key: `5f8f020241905e00153b4c39`,
    value: `${src}usenergysource.com`,
  },
  {
    key: `5f8ecec16e9b00001511b759`,
    value: `${src}www.cleanpowersf.org`,
  },
  {
    key: `5f5f6a06110529001582a006`,
    value: `${src}rocklandcommunitypower.com`,
  },
  { key: `5f74c957d4bebd00158be4b8`, value: `${src}ccaenm.org` },
  { key: `5f5a586bd1ea1c0015ed4f4e`, value: `${src}cal-cca.org` },
  {
    key: `5f8ea27690e87b00159ba00e`,
    value: `${src}www.bartlettec.coop`,
  },
  { key: `5f89f52b0bff1b00167ab336`, value: `${src}bulb.co.uk` },
  {
    key: `5f89dd231700ca0015777a52`,
    value: `${src}energyharbor.com`,
  },
  {
    key: `5f1afe2345c4be00156cbe77`,
    value: `${src}www.svcleanenergy.org`,
  },
  {
    key: `5f88b0fe158c8c00186019cb`,
    value: `${src}www.magenergysolutions.com`,
  },
  { key: `5f888c1ac6291c00184630fe`, value: `${src}www.ouc.com` },
  {
    key: `5f8870fe733e3b0015a24f0d`,
    value: `${src}www.hawaiianelectric.com`,
  },
  {
    key: `5f8765ad4f17bf001558de9c`,
    value: `${src}www.utilitiesinternational.com`,
  },
  {
    key: `5f875b8a0425e00015ffaeca`,
    value: `${src}www.encous.com`,
  },
  {
    key: `5f87427841c4ff0019a8c4fb`,
    value: `${src}billidentity.com`,
  },
  { key: `5f8701676982780015aa3957`, value: `${src}mpua.org` },
  {
    key: `5f85cd029ed2cb001572ab10`,
    value: `${src}website.kiuc.coop`,
  },
  {
    key: `5f8489ab29d2a000156704e2`,
    value: `${src}www.epcor.com`,
  },
  {
    key: `5ef607395da42306c5087947`,
    value: `${src}unitedpower.com`,
  },
  {
    key: `5ef607315da42306c508766a`,
    value: `${src}greenmountainpower.com`,
  },
  {
    key: `5f7deff4b924fa0015c51dd0`,
    value: `${src}www.danskammerenergy.com`,
  },
  {
    key: `5ef6072d5da42306c50874b4`,
    value: `${src}www.avangrid.com`,
  },
  {
    key: `5ef6072d5da42306c508749c`,
    value: `${src}archerenergy.com`,
  },
  {
    key: `5ef6072d5da42306c508749a`,
    value: `${src}www.approvedenergy.com`,
  },
  {
    key: `5ef6072c5da42306c508746d`,
    value: `${src}www.alliantenergy.com`,
  },
  { key: `5ef607325da42306c50876c6`, value: `${src}www.igs.com` },
  { key: `606445a0b954ef001c99d2d8`, value: `${src}cobbemc.com` },
  {
    key: `60636ab1edec8d001b2921ed`,
    value: `${src}www.viwapa.vi`,
  },
  {
    key: `60620dcd1b6362001b1d7644`,
    value: `${src}www.alliantenergy.com`,
  },
  {
    key: `6062018bcbcde7001bf4aa25`,
    value: `${src}www.duke-energy.com`,
  },
  {
    key: `6061c094985413001be40e83`,
    value: `${src}www.wrecc.com`,
  },
  {
    key: `6061b22a4c6d9c001bdf91a4`,
    value: `${src}www.wolverinepowercooperative.com`,
  },
  { key: `605dc3a101ece1001cbf21eb`, value: `${src}www.tid.org` },
  {
    key: `5ef6072e5da42306c5087516`,
    value: `${src}www.cmpco.com`,
  },
  { key: `60507afc4438cb001be43f77`, value: `${src}vea.coop` },
  {
    key: `60598fe698f2dd001c565ba6`,
    value: `${src}www.greenpoweremc.com`,
  },
  {
    key: `60588c8e77bcc1001ef1eac1`,
    value: `${src}www.kymea.org`,
  },
  {
    key: `6054594e9e41cb001b3798f7`,
    value: `${src}www.westernpower.co.uk`,
  },
  {
    key: `60507a704438cb001be43eed`,
    value: `${src}www.commonenergy.us`,
  },
  {
    key: `6050774773b399001ba91159`,
    value: `${src}www.cleco.com`,
  },
  { key: `604ba6545d61a1001b7d87af`, value: `${src}ppi.coop` },
  {
    key: `604b44e130541d001b1fe094`,
    value: `${src}www.springercoop.com`,
  },
  {
    key: `604b44a230541d001b1fe04e`,
    value: `${src}www.smpa.com`,
  },
  { key: `604b445e4dffd1001cdeeb30`, value: `${src}siea.com` },
  {
    key: `604b441a639fa4001cb026cf`,
    value: `${src}www.nrppd.com`,
  },
  {
    key: `604b43e8d539c900206427ca`,
    value: `${src}wheatbelt.com`,
  },
  {
    key: `604a01b25c1cad001b8e6da9`,
    value: `${src}www.homeworks.org`,
  },
  { key: `604a00eec82686001d2a6813`, value: `${src}gsuinc.ca` },
  {
    key: `6048c0e7e434f0001df5b9f0`,
    value: `${src}lamarelectric.coop`,
  },
  {
    key: `60489e8e185d36001b3de03b`,
    value: `${src}discountpower.com`,
  },
  {
    key: `60489aa93b1e63001b05faa4`,
    value: `${src}douglaspud.org`,
  },
  {
    key: `60489a4c409562001ba5c3ab`,
    value: `${src}www.mytpu.org`,
  },
  {
    key: `60476b87ebcf41001be5a40d`,
    value: `${src}eastsidepa.org`,
  },
  {
    key: `60476ab4c64c3b001f6c8d6d`,
    value: `${src}pittsburgpowerco.com`,
  },
  {
    key: `604764b42e57fb001ef3d72f`,
    value: `${src}www.pwrpa.org`,
  },
  {
    key: `5f173a605b91770015a306fd`,
    value: `${src}valleycleanenergy.org`,
  },
  {
    key: `6040fa65cec356001cf7c387`,
    value: `${src}www.pinnaclewest.com`,
  },
  {
    key: `6040f601dc40b6001c2b0f8e`,
    value: `${src}www.glendaleca.gov`,
  },
  {
    key: `603f91f50a23ac001b411e07`,
    value: `${src}www.nisource.com`,
  },
  { key: `60393cacd0e975001c560efe`, value: `${src}loup.com` },
  {
    key: `5fa05e6435a6eb00169472ad`,
    value: `${src}www.dpandl.com`,
  },
  {
    key: `5fa05a373e447d0015d7ac52`,
    value: `${src}www.iplpower.com`,
  },
  {
    key: `6034cd3019fb95001b9f9516`,
    value: `${src}www.solarisenergyllc.com`,
  },
  {
    key: `6034193a31987f001cb3962d`,
    value: `${src}sanjosecleanenergy.org`,
  },
  {
    key: `602bb2400e03a9001b216820`,
    value: `${src}www.mmwec.org`,
  },
  {
    key: `602518e044190a001ba9293c`,
    value: `${src}www.blackhillsenergy.com`,
  },
  {
    key: `6023cb26fa462c001b135c6e`,
    value: `${src}cacommunitypower.org`,
  },
  {
    key: `6022b5f9af45a9001b4e98fb`,
    value: `${src}www.burlingtonelectric.com`,
  },
  {
    key: `6021c090f03dcd001bdb27e8`,
    value: `${src}www.communitypowernh.org`,
  },
  { key: `601d82db21dcca001e27e008`, value: `${src}www.cfu.net` },
  { key: `601c4def61e7e2001d5cdc33`, value: `${src}www.gru.com` },
  {
    key: `5f173573fdf69600158d07eb`,
    value: `${src}www.uppco.com`,
  },
  {
    key: `601848da3ee002001c67bf87`,
    value: `${src}www.tnmp.com`,
  },
  {
    key: `60184896626028001cf166e5`,
    value: `${src}www.reliant.com`,
  },
  {
    key: `5f19ea80d22d47001545768e`,
    value: `${src}www.mcecleanenergy.org`,
  },
  {
    key: `5f1b410c64470e0015cb44b2`,
    value: `${src}www.powercompanyofwyoming.com`,
  },
  {
    key: `6013d6e5069c43001be185ec`,
    value: `${src}msrpower.org`,
  },
  {
    key: `60130c28973082001ddb5eb2`,
    value: `${src}gus.georgetown.org`,
  },
  {
    key: `6011d1ab3ff568001bcbc8c7`,
    value: `${src}www.hged.com`,
  },
  {
    key: `6011c92b7d3674001b31cec9`,
    value: `${src}www.southernpowercompany.com`,
  },
  {
    key: `60118980206015001ed95c8c`,
    value: `${src}www.clarksvilleconnected.net`,
  },
  {
    key: `60117c214cb14a001b3ac88c`,
    value: `${src}wppienergy.org`,
  },
  {
    key: `5f4feb5f72c6af0016cfa5b6`,
    value: `${src}www.gvea.com`,
  },
  {
    key: `60105bf9bed0f1001b79ed24`,
    value: `${src}farmerselectric.coop`,
  },
  {
    key: `601039da60f539001b294414`,
    value: `${src}www.opuda.org`,
  },
  {
    key: `5fb37e8fb76fc0001bfbe6e8`,
    value: `${src}www.chelanpud.org`,
  },
  { key: `600f2c638be10b001b3c28fd`, value: `${src}clpud.org` },
  { key: `600b0a2ba282ff001b44cc8d`, value: `${src}www.oru.com` },
  {
    key: `600b09e8718e85001c24a380`,
    value: `${src}www.cenhud.com`,
  },
  {
    key: `6009d0c7d04c14001e63aa89`,
    value: `${src}www.ncelectriccooperatives.com`,
  },
  {
    key: `6009d01fc53652001b44e6dc`,
    value: `${src}www.hoosierenergy.com`,
  },
  { key: `6009cf267f39ba001ba0aa7b`, value: `${src}ohioec.org` },
  { key: `60071b19aaa5bf001c301af2`, value: `${src}www.mpw.org` },
  {
    key: `6005ef9b57e1ad001fe5cb5f`,
    value: `${src}www.halifaxemc.com`,
  },
  {
    key: `60057c8db01eff001e2df402`,
    value: `${src}www.skens.com`,
  },
  {
    key: `6001b0263c360a001b3ef29f`,
    value: `${src}www.bchydro.com`,
  },
  {
    key: `5ffc8373bc07f0001f2ef32e`,
    value: `${src}ww5.cityofpasadena.net`,
  },
  {
    key: `5ff72f81351ab8001be05df6`,
    value: `${src}www.swepco.com`,
  },
  {
    key: `5ff381ee263caf001c7da19e`,
    value: `${src}norrisppd.com`,
  },
  {
    key: `5fecce10d4b87b001ba63b59`,
    value: `${src}www.loudonutilities.org`,
  },
  {
    key: `5fec8fa674aecb001b3ab639`,
    value: `${src}www.stec.org`,
  },
  {
    key: `5feb1be6c36c37001c152ba7`,
    value: `${src}www.wvpa.com`,
  },
  { key: `5fe9d547dd47fb001e56d9d8`, value: `${src}undefined` },
  {
    key: `5fe4cdd5988edd001cba9771`,
    value: `${src}sanmarcostx.gov`,
  },
  { key: `5fe10eb59a22c9001bf435fa`, value: `${src}carkw.com` },
  { key: `5fe051bcf90797001b4afc47`, value: `${src}enagas.es` },
  { key: `5fdcf60ee74d2c001ce1d3a2`, value: `${src}undefined` },
  {
    key: `5fdcf5e0d479b2001be5495c`,
    value: `${src}www.nbutexas.com`,
  },
  {
    key: `5fdcf5b9caa648001b4b7d5d`,
    value: `${src}www.gpltexas.org`,
  },
  {
    key: `5fdcf5810d0b9d001b167f53`,
    value: `${src}www.cityofdenton.com`,
  },
  {
    key: `5fdcb53a94f674001b7080e1`,
    value: `${src}www.socalgas.com`,
  },
  { key: `5fd3b227aafaeb001b7ae81c`, value: `${src}www.mvv.de` },
  {
    key: `5fd27f5162a0b4001bbf49a7`,
    value: `${src}www.gvec.org`,
  },
  { key: `5fd26e7249f9d1001df9216b`, value: `${src}ucs.net` },
  {
    key: `5fd241d4673325001bcdc48c`,
    value: `${src}summerside.hosted.civiclive.com`,
  },
  {
    key: `5fd23f85df3746001bfdb870`,
    value: `${src}www.meagpower.org`,
  },
  {
    key: `5fd130af17dc2e001ba0063c`,
    value: `${src}www.hydroquebec.com`,
  },
  {
    key: `5fd12cdc1392dd001b6b0ffc`,
    value: `${src}www.waltonemc.com`,
  },
  {
    key: `5fcf9aac0c0f02001baadb74`,
    value: `${src}www.umatillaelectric.com`,
  },
  {
    key: `60fa91148b6d46001eb6c82f`,
    value: `${src}www.touchstoneenergy.com`,
  },
  {
    key: `5f109bebd5c6f500156d98bc`,
    value: `${src}www.tristategt.org`,
  },
  {
    key: `61018d0bc041d9001f96d73e`,
    value: `${src}emkeyenergy.com`,
  },
  {
    key: `5ef607355da42306c5087801`,
    value: `${src}www.portlandgeneral.com`,
  },
  {
    key: `5f1b14ac33ddc60016e96174`,
    value: `${src}www.tannerelectric.coop`,
  },
  {
    key: `5f1b04e32b82b6001516ba96`,
    value: `${src}www.altagas.ca`,
  },
  {
    key: `5f1b03fd1cd2db0016b079f5`,
    value: `${src}www.evergy.com`,
  },
  {
    key: `5f1b02ea6166c5001685f404`,
    value: `${src}www.uamps.com`,
  },
  {
    key: `5f1b00aa2b82b6001516b2a5`,
    value: `${src}www.taqa.com`,
  },
  {
    key: `60ffe101c35c02001f857b93`,
    value: `${src}www.northerngrid.net`,
  },
  {
    key: `5f1aeddda0295c00162f1bab`,
    value: `${src}www.pud-ri.org`,
  },
  {
    key: `5f19ee650182f3001636e8da`,
    value: `${src}my.xcelenergy.com`,
  },
  {
    key: `5f1aec55530d560015a3219b`,
    value: `${src}www.pacificpower.net`,
  },
  {
    key: `5f19e95275f51600164ad111`,
    value: `${src}www.logansportutilities.com`,
  },
  { key: `5f19e376428fd80016b813e1`, value: `${src}lge-ku.com` },
  {
    key: `5f19edcfb284410015d93034`,
    value: `${src}www.minnkota.com`,
  },
  { key: `6110ffba4443cf001e44de03`, value: `${src}mpua.org` },
  {
    key: `610d0336a89e2f001e7cd7e1`,
    value: `${src}www.greenmountainenergy.com`,
  },
  {
    key: `5f183fde662cc6001601ac8f`,
    value: `${src}www.duke-energy.com`,
  },
  { key: `610928373af5a5001ef0cad0`, value: `${src}ugies.com` },
  {
    key: `6111529f020b64001e1d899f`,
    value: `${src}www.cityofharborsprings.com`,
  },
  {
    key: `611181bc310da8001e3cb610`,
    value: `${src}www.ovec.com`,
  },
  {
    key: `61129702a9003c001e71a233`,
    value: `${src}www.ovec.com`,
  },
  {
    key: `6112a0a1a50fe4001edd87aa`,
    value: `${src}www.madelec.net`,
  },
  {
    key: `5ef6072c5da42306c508742e`,
    value: `${src}www.publicpower.com`,
  },
]

export const developers = [
  {
    key: `5f88544d7201270017210705`,
    value: `${src}assocenergy.com`,
  },
  {
    key: `60f6c9acdde8a3001fa1881e`,
    value: `${src}assocenergy.com`,
  },
  {
    key: `60f6b044d296a3001e22164c`,
    value: `${src}www.quonset.com`,
  },
  {
    key: `60f684676ebe07001e9d1786`,
    value: `${src}bioenergydevco.com`,
  },
  {
    key: `60f54f95fbb529001f054c50`,
    value: `${src}cleanbayrenewables.com`,
  },
  {
    key: `60f5432ae16c48001e1c0129`,
    value: `${src}aglandrenewables.com`,
  },
  {
    key: `60f51fd0a83b6c001e9f45c0`,
    value: `${src}assocenergy.com`,
  },
  {
    key: `60f17084cb06e0001e5b61b4`,
    value: `${src}www.atlanticterminals.com`,
  },
  {
    key: `60f14ed343dae6001eb7e610`,
    value: `${src}www.volt-energy.com`,
  },
  {
    key: `60f140787c7188001ec7c63e`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `60f02bc535d2d5001e8993bc`,
    value: `${src}nevadacopper.com`,
  },
  {
    key: `60f014dd87b04e001fc6e098`,
    value: `${src}www.tidewatermidstream.com`,
  },
  {
    key: `60ee743deb7452001e7bb684`,
    value: `${src}www.dakotapp.com`,
  },
  {
    key: `60eeb3a6b6f2c0001eed0145`,
    value: `${src}www.greengenstorage.com`,
  },
  {
    key: `60ee92c838ba00001ef89591`,
    value: `${src}www.maltainc.com`,
  },
  {
    key: `60ee900238ba00001ef890ce`,
    value: `${src}www.arborgas.com`,
  },

  { key: `60ec3a83635705001e64043d`, value: `${src}ingenco.com` },
  {
    key: `60ec16cc7f4cbf002111789c`,
    value: `${src}sandhillsenergy.com`,
  },
  {
    key: `60e823591dd8f4001e68f246`,
    value: `${src}powermarket.io`,
  },
  {
    key: `60e68acaaf35fe001f9230c3`,
    value: `${src}www.zaubacorp.com`,
  },
  {
    key: `60e596f6bd06a9001f9ea504`,
    value: `${src}nextrenewables.com`,
  },
  {
    key: `60e32792ec3757001e9fdc6f`,
    value: `${src}www.theboldtcompany.com`,
  },
  {
    key: `60d462f0e9a394001fe1cde7`,
    value: `${src}www.EmpowerEnergies.com`,
  },
  {
    key: `60dd7f63a4635b001ed8a4e9`,
    value: `${src}www.apv-mw.com`,
  },
  { key: `60dd64993ee8b6001fab5e87`, value: `${src}avolta.us` },
  {
    key: `60d98b278c7000001fc93738`,
    value: `${src}www.sagegeosystems.com`,
  },
  {
    key: `60d98a3d8c7000001fc935e9`,
    value: `${src}geoxenergy.com`,
  },
  {
    key: `60d97d748c7000001fc9178f`,
    value: `${src}opendatany.com`,
  },
  {
    key: `60d5a2c960ad26001ed291ce`,
    value: `${src}www.prioritypower.net`,
  },
  {
    key: `60d44407e9a394001fe19098`,
    value: `${src}www.wvresc.com`,
  },
  {
    key: `60d3431029ca67001fa735ae`,
    value: `${src}www.neo-llc.com`,
  },
  {
    key: `60d309c3f18231001fa9620e`,
    value: `${src}questfwe.com`,
  },
  {
    key: `60d30788bd4f9200202d6312`,
    value: `${src}ciercoenergy.com`,
  },
  {
    key: `60d1ab9cd4aae200222766c5`,
    value: `${src}www.brightmark.com`,
  },
  {
    key: `5ef607385da42306c50878d1`,
    value: `${src}www.stratasolar.com`,
  },
  {
    key: `60d0cc7068e7cd001ee502e6`,
    value: `${src}www.highfieldenergy.com`,
  },
  {
    key: `60d04b8e3ab61c001e0577ef`,
    value: `${src}silvergraingroup.com`,
  },
  { key: `60ccd6b018605f0021cfa55c`, value: `${src}grs.energy` },
  {
    key: `60cb1419069b3600205003e7`,
    value: `${src}www.bizapedia.com`,
  },
  {
    key: `60cc488e0a000c001ec3d5b4`,
    value: `${src}www.cabansystems.com`,
  },
  {
    key: `60cbbf38f736ec001e1cd89d`,
    value: `${src}www.sserenewables.com`,
  },
  {
    key: `60cb82e3aca7d0001e623ada`,
    value: `${src}www.nexuspwr.com`,
  },
  {
    key: `5ef607395da42306c508794f`,
    value: `${src}www.uswindinc.com`,
  },
  {
    key: `5ef607335da42306c508772e`,
    value: `${src}www.mainstreamrp.com`,
  },
  {
    key: `60ca10d76192b5001eb50a5e`,
    value: `${src}www.bizapedia.com`,
  },
  {
    key: `60c9e978572c86001fc60f41`,
    value: `${src}flycatcherllc.com`,
  },
  {
    key: `60c865dc6f19680020d86ce3`,
    value: `${src}davekolbgrading.com`,
  },
  {
    key: `60c9c270f6e58f001ed428ff`,
    value: `${src}spanosolarenterprises.com`,
  },
  {
    key: `60c97dbef6e58f001ed3ab36`,
    value: `${src}kendallsustainableinfrastructure.com`,
  },
  {
    key: `60c8cbe6d6c395001e94b7bf`,
    value: `${src}novisrenew.com`,
  },
  {
    key: `60c88e136f19680020d8c288`,
    value: `${src}westbridgecorp.ca`,
  },
  {
    key: `60c73ceb54cba4001e3b82e8`,
    value: `${src}www.bluefloat.com`,
  },
  {
    key: `60c7043e6132460020a4b23f`,
    value: `${src}urbanxgroup.com`,
  },
  {
    key: `60c6de3ab9536a001e11d6dd`,
    value: `${src}www.ariaenergy.com`,
  },
  {
    key: `5ef607355da42306c50877c8`,
    value: `${src}www.ormat.com`,
  },
  {
    key: `60c1fedb5dfae2001f0a3b50`,
    value: `${src}www.enel.com`,
  },
  {
    key: `60c1a3d27b924b001e88ac4e`,
    value: `${src}riselight.com`,
  },
  { key: `60c1a3130fa091001e109ed0`, value: `${src}convalt.com` },
  {
    key: `60c0bd2d0e1361001fa54add`,
    value: `${src}www.aersoleir.com`,
  },
  {
    key: `60c0725e732418001f5bd175`,
    value: `${src}shockoesolar.com`,
  },
  { key: `60c070c6529ea1001e0097ae`, value: `${src}cirenew.com` },
  {
    key: `60bf774fc2c07f0020e02ada`,
    value: `${src}www.enlightenergy.co.il`,
  },
  {
    key: `60bf1d9165b545001ec0b4fc`,
    value: `${src}bsd.sos.in.gov`,
  },
  {
    key: `60b9bae8383d4b001e2e77b1`,
    value: `${src}westerncommunityenergy.com`,
  },
  {
    key: `60b7c2e9074b89001f34bc51`,
    value: `${src}halyardenergy.com`,
  },
  { key: `60b7bc6b1ffcb6001e7408bc`, value: `${src}arctas.com` },
  {
    key: `60ae47995998d6001e045298`,
    value: `${src}www.upcrenewables.com`,
  },
  {
    key: `5ef607315da42306c5087634`,
    value: `${src}foundationsolarpartner.com`,
  },
  {
    key: `5ef6072d5da42306c50874e2`,
    value: `${src}www.borregosolar.com`,
  },
  { key: `60acff5ce37ca9001f658b1a`, value: `${src}sec.report` },
  {
    key: `5f1b110c45c4be00156d3823`,
    value: `${src}www.oridenpower.com`,
  },
  {
    key: `5f6df1e14a81e600173d5fed`,
    value: `${src}vermontstandardoffer.com`,
  },
  {
    key: `60a7a21c64cf2f00223e1a18`,
    value: `${src}sndevcorp.ca`,
  },
  {
    key: `60a62d360324f1001f1a0970`,
    value: `${src}skypower.com`,
  },
  {
    key: `60a4ca4cbf6550001bb7379c`,
    value: `${src}www.fervoenergy.com`,
  },
  {
    key: `60a24153bb3aa5001bf5dc9d`,
    value: `${src}www.3g-energy.com`,
  },
  {
    key: `60a22e6cc1d927001b62c032`,
    value: `${src}trilateralpacific.com`,
  },
  {
    key: `60a1e96f2b955e001c981c8b`,
    value: `${src}norbutsolarfarms.com`,
  },
  {
    key: `609e72fca323de001bdff06e`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `609e363d33495f001e9c4688`,
    value: `${src}www.appalachianenergyinc.com`,
  },
  {
    key: `609e20bc0e6977001b8e1909`,
    value: `${src}www.midwestwind.com`,
  },
  {
    key: `609d0438ee26d1001bb09505`,
    value: `${src}wattswind.com`,
  },
  { key: `609aa7526544ff001b65a28a`, value: `${src}frv.com` },
  {
    key: `609aa4502309bb001b037db3`,
    value: `${src}frontier-renewables.com`,
  },
  {
    key: `60993d4f2ec6cf001c16cd22`,
    value: `${src}terawattinfrastructure.com`,
  },
  {
    key: `60991956b80aed001b874ad5`,
    value: `${src}www.wattev.com`,
  },
  {
    key: `6098de57af447f001ce6f746`,
    value: `${src}edp-energy.com`,
  },
  {
    key: `6098cfa1981ec2001b055fad`,
    value: `${src}endurant.com`,
  },
  {
    key: `5f1b0c981b31b10015aa213e`,
    value: `${src}www.lspower.com`,
  },
  {
    key: `6095447699d661001b2bbf46`,
    value: `${src}aresnorthamerica.com`,
  },
  {
    key: `6092e0d2d05bf7001ebc60b4`,
    value: `${src}www.solarproponent.com`,
  },
  {
    key: `6092aa04350702001e106ab7`,
    value: `${src}www.aepohio.com`,
  },
  {
    key: `608fe81048a75d001ba5d333`,
    value: `${src}sustainablesolutions.duke-energy.com`,
  },
  {
    key: `608fa0c782183c001d08543b`,
    value: `${src}catcreek-energy.com`,
  },
  { key: `608bed6c1690ee001bf9b6ec`, value: `${src}ibersun.es` },
  {
    key: `608a558b6e8646001d59672d`,
    value: `${src}hoosiersolar.com`,
  },
  {
    key: `608956ca36200d001c2c0e5f`,
    value: `${src}www.lspgridnewyork.com`,
  },
  {
    key: `5fff063c5e94f9001cd55367`,
    value: `${src}www.nexteraenergycanada.com`,
  },
  {
    key: `60868215503ba7001b72aefd`,
    value: `${src}beowulfenergy.com`,
  },
  {
    key: `608167659d6bcd001b7039ba`,
    value: `${src}matrixrenewables.com`,
  },
  {
    key: `5f7e05132a7eda0015bfb3b3`,
    value: `${src}www.eolusvind.com`,
  },
  {
    key: `60813d0f021999001ccc4ec7`,
    value: `${src}www.eolusnorthamerica.com`,
  },
  {
    key: `607ea1777ba7ed001f25490f`,
    value: `${src}www.prnewswire.com`,
  },
  {
    key: `607d5f1aca26bb001d866fff`,
    value: `${src}seawestinc.com`,
  },
  {
    key: `5f528852c78ddf001654a178`,
    value: `${src}dimension-energy.com`,
  },
  {
    key: `607883a954bdd5001bd08b7d`,
    value: `${src}d3energy.com`,
  },
  {
    key: `5ef6072b5da42306c508741e`,
    value: `${src}o3energy.com`,
  },
  {
    key: `6076ca94741e61001b82e9e9`,
    value: `${src}www.nuquestenergy.com`,
  },
  {
    key: `60743e54b4266b001bdf73fc`,
    value: `${src}www.skyfireenergy.com`,
  },
  {
    key: `60743d66a9d9fd001b4a248a`,
    value: `${src}www.alltradeindustrial.com`,
  },
  {
    key: `607435ff5f2c2f001c399edb`,
    value: `${src}bmrenergy.com`,
  },
  {
    key: `5f1b11a01cd2db0016b0a5a8`,
    value: `${src}www.pointreyesenergy.com`,
  },
  {
    key: `607003c130281f001d433e81`,
    value: `${src}ia.cpuc.ca.gov`,
  },
  {
    key: `606f48f829a39a001b2e3eb1`,
    value: `${src}www.nalarenewables.com`,
  },
  {
    key: `606f469bda3556001d5f5ca6`,
    value: `${src}progression-energy.com`,
  },
  {
    key: `5fb581ae9da7a4001b1858f4`,
    value: `${src}usa.ric.energy`,
  },
  {
    key: `5f1edfc7eebf5300154e11af`,
    value: `${src}www.natrs.com`,
  },
  {
    key: `606584fdbcb46f001ce55b73`,
    value: `${src}europeanenergy.com`,
  },
  {
    key: `5f7cc5785f52340015373218`,
    value: `${src}altarockenergy.com`,
  },
  {
    key: `5f7cb0d5701d500015f1e230`,
    value: `${src}sunchasepower.com`,
  },
  {
    key: `5f400bcdc558ae001839a03d`,
    value: `${src}ips-solar.com`,
  },
  {
    key: `5ef607335da42306c50876e8`,
    value: `${src}www.sonnedix.com`,
  },
  {
    key: `5f7c7566997f370015cfa00e`,
    value: `${src}grasshopperenergy.com`,
  },
  { key: `5f7c57a3abbd480017b8e1ec`, value: `${src}seia.org` },
  {
    key: `5f7b69b42688150015aee457`,
    value: `${src}berrendoenergy.com`,
  },
  {
    key: `5f7b677db783fa00159d22fd`,
    value: `${src}www.energix-group.com`,
  },
  {
    key: `5f7b4e42701d500015f05f0f`,
    value: `${src}www.gridliance.com`,
  },
  {
    key: `5f7b4ab5cd19ed0017067a05`,
    value: `${src}greenlots.com`,
  },
  {
    key: `5ef607325da42306c50876a8`,
    value: `${src}heelstoneenergy.com`,
  },
  { key: `5f75ef434ea9bd0018e7dfd1`, value: `${src}bwsolar.com` },
  {
    key: `5ef607345da42306c5087798`,
    value: `${src}www.nexteraenergytransmission.com`,
  },
  {
    key: `5f6dfdac2c8a94001529980e`,
    value: `${src}www.greenpeaksolar.com`,
  },
  {
    key: `5f75d2649e4034001539232a`,
    value: `${src}assocenergy.com`,
  },
  {
    key: `5f75a0fdd26efb00162bb6fd`,
    value: `${src}petronenergyii.com`,
  },
  {
    key: `5f74d4644a66b900179aaa81`,
    value: `${src}www.o2emc.com`,
  },
  {
    key: `5f74d1ee48b65c00153747dc`,
    value: `${src}www.entegritypartners.com`,
  },
  {
    key: `5f74370e5e98b40015a57f61`,
    value: `${src}ls-energy.com`,
  },
  {
    key: `5f72ece3d347750015b98a3b`,
    value: `${src}www.cenergypower.com`,
  },
  {
    key: `5f720d7de6dbf80015b6f6c3`,
    value: `${src}www.glenvale.solar`,
  },
  {
    key: `5f71abaaf8fc810015c7082a`,
    value: `${src}www.sunlightgeneral.com`,
  },
  {
    key: `5f6e550b4a81e60017402341`,
    value: `${src}www.olivewoodenergy.com`,
  },
  {
    key: `5f6df0c04a81e600173d5a3e`,
    value: `${src}greenpowerenergy.com`,
  },
  {
    key: `5f6de36cbc03e00015de2dac`,
    value: `${src}gosmartsolar.com`,
  },
  {
    key: `5f6ca316ed84580015461e27`,
    value: `${src}www.earthsparkinternational.org`,
  },
  {
    key: `5ef607335da42306c5087720`,
    value: `${src}www.lightboxenergy.com`,
  },
  {
    key: `5f6c85eaed84580015455c6d`,
    value: `${src}www.renergetica.us`,
  },
  {
    key: `5f6c7aa346d9990016739278`,
    value: `${src}www.atlasrenewableenergy.com`,
  },
  {
    key: `5f6c798ced84580015450ed8`,
    value: `${src}www.azimuthrenew.com`,
  },
  {
    key: `5f624f0f721fd500153db49e`,
    value: `${src}www.energysource.us.com`,
  },
  {
    key: `5f5f7dd3616c110015af898a`,
    value: `${src}www.cadenenergix.com`,
  },
  {
    key: `5f5a10af1599410015622bf5`,
    value: `${src}www.windlab.com`,
  },
  {
    key: `5efcbd1a8122350017a957d1`,
    value: `${src}www.buffalourbandevelopment.com`,
  },
  {
    key: `5f58d5b02b17ea001510afa3`,
    value: `${src}tyrenergy.com`,
  },
  {
    key: `5f58cfc4f123ce0015e94926`,
    value: `${src}www.sunisticsgroup.com`,
  },
  {
    key: `5f5290e038674200178d4226`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5f51233c970468001504dd0b`,
    value: `${src}cielowind.com`,
  },
  {
    key: `5f4fd71d6de5c300151f481a`,
    value: `${src}www.cyrqenergy.com`,
  },
  {
    key: `5f4fd66a6de5c300151f45e6`,
    value: `${src}www.crunchbase.com`,
  },
  {
    key: `5f4fc95b45e616001565b8c9`,
    value: `${src}www.carsonhybridenergystorage.com`,
  },
  {
    key: `5f4fc85c73820e0015e7227c`,
    value: `${src}www.iepwr.com`,
  },
  {
    key: `5f4fc38b53d59f001648fd93`,
    value: `${src}suntribesolar.com`,
  },
  {
    key: `5f4fc0706de5c300151ed8ee`,
    value: `${src}www.sunedison.com`,
  },
  { key: `5ef6073c5da42306c5087983`, value: `${src}www.wpd.de` },
  {
    key: `5f4e5b4bdcca4e00169f903e`,
    value: `${src}www.dgen.energy`,
  },
  { key: `5ef607355da42306c50877cb`, value: `${src}orsted.com` },
  {
    key: `5f47b4d526ce5a00164b613c`,
    value: `${src}www.cogentrix.com`,
  },
  {
    key: `5f46c1843573410016b53c93`,
    value: `${src}coresolarllc.com`,
  },
  {
    key: `5f46c126aaa68600154cb8ae`,
    value: `${src}www.northlightenergy.solar`,
  },
  {
    key: `5f4577718cac3d00154630bc`,
    value: `${src}www.raienergy.com`,
  },
  {
    key: `5f4576b68cac3d0015462fc6`,
    value: `${src}agilitasenergy.com`,
  },
  {
    key: `5f451ee703cb02001542114c`,
    value: `${src}www.vineyardwind.com`,
  },
  {
    key: `5f43ed02cd510c00153df392`,
    value: `${src}www.northlandpower.com`,
  },
  {
    key: `5f3fcff66b3e110019df81fc`,
    value: `${src}www.brightcanyonenergy.com`,
  },
  {
    key: `5f3ecdc7632c2c0015a948f4`,
    value: `${src}www.encous.com`,
  },
  {
    key: `5f3ecd73679a59001762ea92`,
    value: `${src}www.samsungrenewableenergy.ca`,
  },
  {
    key: `5f3ec9d03791070016ecef95`,
    value: `${src}www.imwind.at`,
  },
  {
    key: `5f3d621ebcff2b0018b0d66d`,
    value: `${src}nebraska.solar`,
  },
  {
    key: `5f3d47bf825044001510a5ea`,
    value: `${src}www.brightes.com`,
  },
  {
    key: `5f3c4a05526afe0015d0f1b2`,
    value: `${src}www.linxon.com`,
  },
  {
    key: `5f3c3c752f582700150ab8e9`,
    value: `${src}www.renesolapower.com`,
  },
  {
    key: `5f3c1286f548730015a550cd`,
    value: `${src}www.fuelcellenergy.com`,
  },
  {
    key: `5f3aca5349166b0015becbc9`,
    value: `${src}www.gspp.com`,
  },
  {
    key: `5f3abf6361940d0015635e2b`,
    value: `${src}newenergynorthamerica.com`,
  },
  {
    key: `5f1b09877e615a00155aeb53`,
    value: `${src}www.soogreenrr.com`,
  },
  { key: `5f35d350ea10cc00158edf30`, value: `${src}masdar.ae` },
  {
    key: `5ef607395da42306c508793f`,
    value: `${src}www.ugei.com`,
  },
  {
    key: `5ef607335da42306c5087716`,
    value: `${src}www.leedco.org`,
  },
  {
    key: `5f33f8ae0d6f29001706bc89`,
    value: `${src}harvestsolar.com`,
  },
  {
    key: `5f31ec5786b5f700169ce700`,
    value: `${src}omni-navitas.com`,
  },
  {
    key: `5f31eb1c86b5f700169ce406`,
    value: `${src}sourcerenew.com`,
  },
  {
    key: `5f31991c1b2062001505f4ca`,
    value: `${src}www.brightcoreenergy.com`,
  },
  {
    key: `5ef6072b5da42306c5087422`,
    value: `${src}174powerglobal.com`,
  },
  { key: `5f318c0420786f0015b5d5f8`, value: `${src}bnrg.ie` },
  {
    key: `5f3181f07c63820015f004ee`,
    value: `${src}www.dirigosolar.com`,
  },
  {
    key: `5f317802eed6c20016c5b67d`,
    value: `${src}www.indianenergy.com`,
  },
  {
    key: `5f2f5736f0c64f0015562351`,
    value: `${src}www.sunwalkerenergy.com`,
  },
  { key: `5f2f52052a79ad0015f3b6a5`, value: `${src}mgilp.com` },
  {
    key: `5f2c08accd74a10015554bdf`,
    value: `${src}www.komipo.co.kr`,
  },
  { key: `5f2c056b54b3e5001593ca01`, value: `${src}meritsi.com` },
  {
    key: `5f2aedbc620ead0015714341`,
    value: `${src}www.stewardshipenergy.com`,
  },
  {
    key: `5f29957a499f7e0018e7d048`,
    value: `${src}www.kearsargeenergy.com`,
  },
  {
    key: `5f298bb084114c0015c48a7b`,
    value: `${src}www.aurapower.co.uk`,
  },
  {
    key: `5f29857784114c0015c474c4`,
    value: `${src}www.eastlightpartners.com`,
  },
  {
    key: `5f29725fa7b30a0015102f83`,
    value: `${src}www.1099energy.com`,
  },
  {
    key: `5f2970c13bb98c001500c2da`,
    value: `${src}edenrenewables.com`,
  },
  {
    key: `5f28588e5af0260015046287`,
    value: `${src}www.dakotapp.com`,
  },
  {
    key: `5f283b97c4cda200152f39ba`,
    value: `${src}www.elumis.com`,
  },
  {
    key: `5f24826fcbd97f001591cdc5`,
    value: `${src}www.energycgllc.com`,
  },
  {
    key: `5f247cf613b21600151a275f`,
    value: `${src}energyconcepts.us`,
  },
  {
    key: `5f241cda77fad7001a4acad5`,
    value: `${src}frey-electric.com`,
  },
  {
    key: `5f231d552049b600158e8183`,
    value: `${src}conedceb.com`,
  },
  {
    key: `5f2317ef024f0e0015444e00`,
    value: `${src}www.communitypowergroup.com`,
  },
  {
    key: `5f23163242fda70016c15d7c`,
    value: `${src}albertacorporations.com`,
  },
  {
    key: `5f23112071dd10001876bfab`,
    value: `${src}www.gridflexenergy.com`,
  },
  {
    key: `5f230866f36ef20015bc3e07`,
    value: `${src}www.activesolarusa.com`,
  },
  {
    key: `5f21c4de27d0bb00152eef67`,
    value: `${src}cegsolutions.com`,
  },
  {
    key: `5f21c0a45a8ec600159ea5e8`,
    value: `${src}caprockrenewables.com`,
  },
  {
    key: `5f21beaf4e5a7500158d6996`,
    value: `${src}canyonpointenergy.com`,
  },
  {
    key: `5f21839f4e5a7500158be99f`,
    value: `${src}www.boralex.com`,
  },
  {
    key: `5f2049d47a1cfd001677f9c6`,
    value: `${src}potentiarenewables.com`,
  },
  {
    key: `5f1f2903e65b9f0016528dd7`,
    value: `${src}canada.wpd.de`,
  },
  {
    key: `5f1efbb7e65b9f001651440a`,
    value: `${src}www.atlanticenergyconcepts.com`,
  },
  {
    key: `5f1b46fb889903001555638a`,
    value: `${src}daybreakpower.com`,
  },
  {
    key: `5f1b4320911fc40015ce85c5`,
    value: `${src}rpmaccess.com`,
  },
  {
    key: `5f1b326162db5e0015ae7f38`,
    value: `${src}www.gaelectric.ie`,
  },
  {
    key: `5f1b1e088bfdce001703524e`,
    value: `${src}www.altisenergy.com`,
  },
  {
    key: `5f1b14dc8bfdce0017031ca7`,
    value: `${src}www.sunraiseinvestments.com`,
  },

  {
    key: `5f1b126c1cd2db0016b0a84f`,
    value: `${src}summitpower.com`,
  },
  {
    key: `5f1b11d8911fc40015ce2bb5`,
    value: `${src}projectresources.net`,
  },
  {
    key: `5f1b0eed1cd2db0016b09c34`,
    value: `${src}www.naturener.us`,
  },
  {
    key: `5f174e0b7c5beb0015975e03`,
    value: `${src}www.communityenergyinc.com`,
  },
  {
    key: `5fce562aaf2a160020555b23`,
    value: `${src}albertacorporations.com`,
  },
  {
    key: `5fce00b72d2a53001c10bb7a`,
    value: `${src}www.greenbriarcapitalcorp.ca`,
  },
  { key: `5fcdd6242d2a53001c107ef8`, value: `${src}www.cre.fr` },
  {
    key: `5fca7bc965cd9d001b2c107c`,
    value: `${src}enerverse.com`,
  },
  {
    key: `5fca750fcb148f001c5e1466`,
    value: `${src}www.renexia.it`,
  },
  {
    key: `5fca700d8501c8001b3174d1`,
    value: `${src}www.energiekontor.com`,
  },
  {
    key: `5fca5361a56da3001ba18020`,
    value: `${src}www.suzlon.com`,
  },
  {
    key: `5fca4ee1e91f82001dba7deb`,
    value: `${src}www.greengoenergy.com`,
  },
  {
    key: `5f04891efb6304001719299e`,
    value: `${src}www.edprnorthamerica.com`,
  },
  {
    key: `5f6df2d52c8a94001529700a`,
    value: `${src}innovativesolarsystemsllc.com`,
  },
  {
    key: `5f18408d9c0aee0015843ad7`,
    value: `${src}www.edf-re.com`,
  },
  {
    key: `5fca058757b944001c6ae40f`,
    value: `${src}www.quantyzed.com`,
  },
  {
    key: `5f5a240763158d00152323b0`,
    value: `${src}www.njrcleanenergyventures.com`,
  },
  {
    key: `5f1b0e127e615a00155b1a42`,
    value: `${src}www.thewindpower.net`,
  },
  {
    key: `5f186ab1abac510015416b32`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5f1ede776395440015ed82a5`,
    value: `${src}www.thewindpower.net`,
  },
  {
    key: `5fa58f0a7d49af001541f07d`,
    value: `${src}www.obton.com`,
  },
  {
    key: `5f1ed37af87f9400151e1b0a`,
    value: `${src}www.manta.com`,
  },
  {
    key: `5f1ef6406395440015ede128`,
    value: `${src}www.cleanenergyprojectbuilder.org`,
  },
  {
    key: `5f1ed17c5a45ec0015fa8def`,
    value: `${src}renewablenw.org`,
  },
  {
    key: `5f1881567317900015488fc1`,
    value: `${src}www.crunchbase.com`,
  },
  {
    key: `5f1afe7d6166c5001685e365`,
    value: `${src}recurrentenergy.com`,
  },
  {
    key: `5f1ed0dd6395440015ed6c45`,
    value: `${src}www.finduslocal.com`,
  },
  {
    key: `5f6ba6c041d1dd00156dd018`,
    value: `${src}www.buzzfile.com`,
  },
  {
    key: `5fa98ad24229bc0017fdd4fa`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5f1ef9a16395440015edeab6`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5fc7566a65d000001bc429ee`,
    value: `${src}www.pioneergreen.com`,
  },
  { key: `5ef607305da42306c50875e2`, value: `${src}www.dnb.com` },
  {
    key: `5f1b46827143500015274ea7`,
    value: `${src}www.edison.com`,
  },
  { key: `5fb64116ac625d001ba4d50f`, value: `${src}orsted.com` },
  {
    key: `5fc68a4a2f8c85001bfacb5a`,
    value: `${src}www.sungridsolutions.com`,
  },
  {
    key: `5fc67890c17746001b61096d`,
    value: `${src}tuccienergyservices.com`,
  },
  {
    key: `5fc67725dc57ce001baf068c`,
    value: `${src}www.tozzigreen.com`,
  },
  {
    key: `5fc5c8ae940442001c248f5a`,
    value: `${src}www.benton-georgia.com`,
  },
  {
    key: `5f1b47a97050050015805012`,
    value: `${src}www.thewindpower.net`,
  },
  {
    key: `5f1757bdbf985b00155a29ba`,
    value: `${src}www.bloomberg.com`,
  },
  {
    key: `5ef6072d5da42306c50874b0`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5ef6072c5da42306c5087444`,
    value: `${src}www.adamsec.coop`,
  },
  {
    key: `5f1b146d33ddc60016e96141`,
    value: `${src}opencorporates.com`,
  },
  { key: `5fc12b2c03526b001bdb082a`, value: `${src}barkley.ca` },
  {
    key: `5ef607355da42306c50877eb`,
    value: `${src}www.photosol.fr`,
  },
  {
    key: `5fbefd22280989001bae52f6`,
    value: `${src}www.sunalphaenergy.com`,
  },
  {
    key: `5fbe862ecb8511001b15fca4`,
    value: `${src}scatecsolar.com`,
  },
  {
    key: `5fbdb3f03af889001b48e420`,
    value: `${src}www.energyintelligencepartners.com`,
  },
  {
    key: `5fbd85a060ce61001b9ef716`,
    value: `${src}vesperenergy.com`,
  },
  {
    key: `5fbd2973a28f8f001b20907d`,
    value: `${src}www.naics.com`,
  },
  {
    key: `5fbcf0b79eed7a001b9f57cb`,
    value: `${src}www.pointenergyinnovations.com`,
  },
  { key: `5fbce461aad32d001b15d267`, value: `${src}undefined` },
  {
    key: `5fbce2a8aad32d001b15d05b`,
    value: `${src}www.renewprop.com`,
  },
  {
    key: `5fbca42af23a8a001bd650c9`,
    value: `${src}www.carlyle.com`,
  },
  {
    key: `5fbb7f8a98cdbf001cd97c13`,
    value: `${src}baseloadpower.ca`,
  },
  {
    key: `5fbb696415ab24001b29fb3f`,
    value: `${src}optimizerenewables.com`,
  },
  {
    key: `5fb79591f8639e001c99ba34`,
    value: `${src}www.hanoversolar.net`,
  },
  {
    key: `5fb679ffb853fd001bb53c05`,
    value: `${src}www.solariantcapital.com`,
  },
  {
    key: `5fb66f69caa628001be444d7`,
    value: `${src}www.alpin-sun.de`,
  },
  {
    key: `5fb64f56ac625d001ba4dc60`,
    value: `${src}powertis.com`,
  },
  {
    key: `5fb645e59132d8001b609a65`,
    value: `${src}www.thermalep.com`,
  },
  {
    key: `5fb4ea28ae1de0001b1e6839`,
    value: `${src}www.holocene-energy.com`,
  },
  {
    key: `5fb3dcdf8bde6d001cd40072`,
    value: `${src}solarstonepartners.com`,
  },
  { key: `5fb3b35ef50d4a0020c5abfb`, value: `${src}pig.energy` },
  {
    key: `5fb3af63b76fc0001bfc1702`,
    value: `${src}peakcleanenergy.com`,
  },
  {
    key: `5fb3aa08b76fc0001bfc11f1`,
    value: `${src}ohrenergy.com`,
  },
  {
    key: `5fb3a3922a8d88001b333686`,
    value: `${src}nikolapower.com`,
  },
  {
    key: `5fb2df4348b95300152b06c0`,
    value: `${src}usa.pfalzsolar.com`,
  },
  {
    key: `5fae70e4bfd3e50016debb04`,
    value: `${src}www.lcra.org`,
  },
  {
    key: `5fae5b8a9dba040015950890`,
    value: `${src}www.eqlenergy.com`,
  },
  {
    key: `5fad3310a8eafc00152e18e9`,
    value: `${src}moxieenergy.com`,
  },
  { key: `5fad15d71732a700156a514a`, value: `${src}undefined` },
  {
    key: `5fac2607e6151600157d045e`,
    value: `${src}mysunshare.com`,
  },
  {
    key: `5f36b3346ce43e0016cee6bd`,
    value: `${src}dsdrenewables.com`,
  },
  {
    key: `5ef607315da42306c508767a`,
    value: `${src}www.greenskies.com`,
  },
  {
    key: `5faac3894f8bed00159e617b`,
    value: `${src}www.revisionenergy.com`,
  },
  {
    key: `5f1b058445c4be00156ce9ab`,
    value: `${src}birchcreekdev.com`,
  },
  {
    key: `5f1b02491b31b10015a9f9ca`,
    value: `${src}www.transaltarenewables.com`,
  },
  {
    key: `5f1af032a0295c00162f214b`,
    value: `${src}renewablenw.org`,
  },
  {
    key: `5f1aef072ef52f001545e425`,
    value: `${src}corporate.pseg.com`,
  },
  {
    key: `5f19de5a75f51600164a8f33`,
    value: `${src}www.ibvpartners.com`,
  },
  {
    key: `5f199c028d6d630015b285ce`,
    value: `${src}acpowerllc.com`,
  },
  {
    key: `5f18a45254a2c80016260c64`,
    value: `${src}www.coneddev.com`,
  },
  {
    key: `5f1884311def0900173e8c6b`,
    value: `${src}sunriseenergyventures.com`,
  },
  {
    key: `5f187f747a497000154bbcb5`,
    value: `${src}silverpineenergy.com`,
  },
  { key: `5f187cc57a497000154bb885`, value: `${src}www.bp.com` },
  {
    key: `5f18796e7317900015486404`,
    value: `${src}www.performanceservices.com`,
  },
  {
    key: `5f18433ae10e540015efad3b`,
    value: `${src}eurusenergy.com`,
  },
  {
    key: `5f1838308d4290001578ca2c`,
    value: `${src}www.bherenewables.com`,
  },
  {
    key: `5f17564afdf69600158dbf3c`,
    value: `${src}www.aspenall.com`,
  },
  {
    key: `5f175517bbc4580016c2857b`,
    value: `${src}www.cenhud.com`,
  },
  {
    key: `5f109e52b7841e0015c0937b`,
    value: `${src}www.solarlandscape.com`,
  },
  {
    key: `5f173dcf5b91770015a319ae`,
    value: `${src}wind.capital`,
  },
  {
    key: `5f17230dfdf69600158c9a28`,
    value: `${src}www.salkaenergy.com`,
  },
  { key: `5f17227d6b426e0015a866c0`, value: `${src}nmreta.com` },
  {
    key: `5f1718536b426e0015a81d7f`,
    value: `${src}www.juwiamericas.com`,
  },
  {
    key: `5f170b6a80e02e00156857a7`,
    value: `${src}www.iberdrola.com`,
  },
  { key: `5f15ef40966bbe0015d33c1d`, value: `${src}www.aep.com` },
  {
    key: `5f15dba781e9ef001615507a`,
    value: `${src}3degreesinc.com`,
  },
  {
    key: `5ef607335da42306c5087714`,
    value: `${src}www.laurelrenewable.com`,
  },
  {
    key: `5ef6072e5da42306c508755c`,
    value: `${src}www.connectgenllc.com`,
  },
  {
    key: `5ef6072d5da42306c5087492`,
    value: `${src}apsolarholdings.com`,
  },
  {
    key: `5ef607345da42306c5087790`,
    value: `${src}www.nextgrid.com`,
  },
  {
    key: `5ef6072c5da42306c508745c`,
    value: `${src}agsolarsolutions.com`,
  },
  { key: `5ef6072f5da42306c5087576`, value: `${src}ccrenew.com` },
  {
    key: `5ef6072d5da42306c50874da`,
    value: `${src}bluearthrenewables.com`,
  },
  {
    key: `5ef607335da42306c5087718`,
    value: `${src}www.leewardenergy.com`,
  },

  {
    key: `5f1057d2ff41470016c508d8`,
    value: `${src}www.idemitsu.com`,
  },
  {
    key: `5ef607325da42306c50876bc`,
    value: `${src}www.esvolta.com`,
  },
  {
    key: `5f10ae83b7841e0015c0ee8f`,
    value: `${src}www.cthermal.com`,
  },
  {
    key: `5f10853bb7841e0015c00e81`,
    value: `${src}www.renewprop.com`,
  },
  {
    key: `5f107e5cff41470016c594f4`,
    value: `${src}www.alpin-sun.de`,
  },
  {
    key: `5f107410cbe230001727cd4e`,
    value: `${src}swiftcurrentenergy.com`,
  },
  { key: `5f105247d5c6f500156bbb22`, value: `${src}7x.energy` },
  {
    key: `5ef607355da42306c50877c6`,
    value: `${src}www.orionrenewables.com`,
  },
  {
    key: `5ef601379ae27606bb897ef5`,
    value: `${src}www.intersectpower.com`,
  },
  {
    key: `5ef607355da42306c50877c0`,
    value: `${src}www.openroadrenewables.com`,
  },
  {
    key: `5ef607355da42306c50877c2`,
    value: `${src}www.optimumrenewables.com`,
  },
  {
    key: `5ef607355da42306c50877be`,
    value: `${src}www.opdenergy.com`,
  },
  {
    key: `5ef607355da42306c50877bc`,
    value: `${src}www.onyxrenewables.com`,
  },
  {
    key: `5ef607355da42306c50877b2`,
    value: `${src}ocisolarpower.com`,
  },
  {
    key: `5ef607355da42306c50877b0`,
    value: `${src}www.obsidianrenewables.com`,
  },
  {
    key: `5ef607355da42306c50877ae`,
    value: `${src}www.oatfieldllc.com`,
  },
  {
    key: `5ef607355da42306c50877aa`,
    value: `${src}www.novera.energy`,
  },
  {
    key: `5ef607345da42306c50877a6`,
    value: `${src}www.novatusenergy.com`,
  },
  {
    key: `5ef607345da42306c50877a0`,
    value: `${src}www.noriker.co.uk`,
  },
  {
    key: `5ef607345da42306c508779e`,
    value: `${src}nordicsolar.eu`,
  },
  {
    key: `5ef607345da42306c508778e`,
    value: `${src}www.nexamp.com`,
  },
  {
    key: `5ef607355da42306c50877d5`,
    value: `${src}www.paladinsolar.com`,
  },
  { key: `5ef607355da42306c50877d7`, value: `${src}palmcap.com` },
  {
    key: `5ef607355da42306c50877dd`,
    value: `${src}patternenergy.com`,
  },
  {
    key: `5ef607355da42306c50877e3`,
    value: `${src}www.permacity.com`,
  },
  {
    key: `5ef607355da42306c50877e7`,
    value: `${src}phelanenergygroup.com`,
  },
  {
    key: `5ef607355da42306c50877ef`,
    value: `${src}pinegaterenewables.com`,
  },
  {
    key: `5ef607355da42306c50877f3`,
    value: `${src}www.pivotenergy.net`,
  },
  {
    key: `5ef607355da42306c50877fb`,
    value: `${src}www.plusenergystorage.com`,
  },
  {
    key: `5ef607355da42306c50877fd`,
    value: `${src}www.plusretech.com`,
  },
  {
    key: `5ef607355da42306c50877ff`,
    value: `${src}www.pointloadpower.com`,
  },
  {
    key: `5ef607365da42306c5087805`,
    value: `${src}powerfinpartners.com`,
  },
  {
    key: `5ef607365da42306c5087807`,
    value: `${src}www.powerworks.com`,
  },
  { key: `5ef607365da42306c5087809`, value: `${src}www.ppcr.gr` },
  {
    key: `5ef607365da42306c508780b`,
    value: `${src}www.premiumenergyholdings.com`,
  },
  {
    key: `5ef6072c5da42306c508745a`,
    value: `${src}agicapital.org`,
  },
  {
    key: `5ef607325da42306c50876a6`,
    value: `${src}www.hecateenergy.com`,
  },
  {
    key: `5ef607345da42306c5087774`,
    value: `${src}natlsolar.com`,
  },
  {
    key: `5ef607345da42306c508777a`,
    value: `${src}nautilussolar.com`,
  },
  {
    key: `5ef607345da42306c5087786`,
    value: `${src}www.newenergyequity.com`,
  },
  {
    key: `5ef6072d5da42306c50874bc`,
    value: `${src}apsolarholdings.com`,
  },
  {
    key: `5ef6072d5da42306c50874de`,
    value: `${src}www.bluerockenergy.com`,
  },
  {
    key: `5ef6072e5da42306c508750c`,
    value: `${src}www.cvegroup.com`,
  },
  {
    key: `5ef607365da42306c508781b`,
    value: `${src}www.puregenpower.com`,
  },
  {
    key: `5ef607345da42306c508775e`,
    value: `${src}www.mooreenergy.com`,
  },
  {
    key: `5ef607345da42306c5087756`,
    value: `${src}modularlifestyles.com`,
  },
  {
    key: `5ef607345da42306c508774c`,
    value: `${src}www.mission.energy`,
  },
  {
    key: `5ef607345da42306c5087746`,
    value: `${src}www.meridiansolar.com`,
  },
  {
    key: `5ef607335da42306c508773c`,
    value: `${src}www.mcpower.com`,
  },
  {
    key: `5ef607335da42306c508772c`,
    value: `${src}www.mw-pv.com`,
  },
  {
    key: `5ef607335da42306c5087726`,
    value: `${src}www.longroadenergy.com`,
  },
  {
    key: `5ef607325da42306c50876ba`,
    value: `${src}www.hudsonenergydev.com`,
  },
  {
    key: `5ef607325da42306c50876b8`,
    value: `${src}horizonwindpower.com`,
  },
  {
    key: `5ef607325da42306c50876b2`,
    value: `${src}heritagewindenergy.com`,
  },
  { key: `5ef607325da42306c50876b0`, value: `${src}hep.global` },
  {
    key: `5ef607325da42306c50876a4`,
    value: `${src}brightnightenergy.com`,
  },
  {
    key: `5ef607325da42306c50876a2`,
    value: `${src}www.headwaterssolar.com`,
  },
  {
    key: `5ef607325da42306c5087692`,
    value: `${src}www.hm-ventures.com`,
  },
  {
    key: `5ef607325da42306c5087682`,
    value: `${src}groundswell.org`,
  },
  {
    key: `5ef607315da42306c5087678`,
    value: `${src}www.greenkeysolar.com`,
  },
  {
    key: `5ef607315da42306c5087676`,
    value: `${src}greengatepower.com`,
  },
  {
    key: `5ef607315da42306c5087668`,
    value: `${src}www.greenlanternsolar.com`,
  },
  {
    key: `5ef607315da42306c5087662`,
    value: `${src}green-ri.com`,
  },
  {
    key: `5ef607315da42306c508765a`,
    value: `${src}www.gravityrenewables.com`,
  },
  {
    key: `5ef607315da42306c5087646`,
    value: `${src}www.geenexsolar.com`,
  },
  {
    key: `5ef607315da42306c5087642`,
    value: `${src}www.gclnewenergy.com`,
  },
  {
    key: `5ef607315da42306c5087640`,
    value: `${src}www.gardnercapital.com`,
  },
  {
    key: `5ef607315da42306c5087636`,
    value: `${src}fredolsenrenewables.com`,
  },
  { key: `5ef607315da42306c5087632`, value: `${src}frv.com` },
  {
    key: `5ef607315da42306c5087630`,
    value: `${src}www.fortum.com`,
  },
  {
    key: `5ef607315da42306c508762a`,
    value: `${src}www.forefrontpower.com`,
  },
  {
    key: `5ef607315da42306c508761a`,
    value: `${src}www.falckrenewables.eu`,
  },
  {
    key: `5ef607315da42306c5087616`,
    value: `${src}www.exuspartners.com`,
  },
  {
    key: `5ef607305da42306c50875f4`,
    value: `${src}www.eolfi.com`,
  },
  {
    key: `5ef607305da42306c50875f2`,
    value: `${src}enyo-energy.com`,
  },
  {
    key: `5ef607305da42306c50875ea`,
    value: `${src}www.entersolar.com`,
  },
  {
    key: `5ef607305da42306c50875e0`,
    value: `${src}enery.energy`,
  },
  {
    key: `5ef607305da42306c50875cc`,
    value: `${src}www.enelgreenpower.com`,
  },
  {
    key: `5ef607305da42306c50875ca`,
    value: `${src}encorerenewableenergy.com`,
  },
  { key: `5ef6072e5da42306c5087514`, value: `${src}www.enbw.us` },
  { key: `5ef607305da42306c50875c8`, value: `${src}www.emv.gr` },
  { key: `5ef607305da42306c50875c2`, value: `${src}ellomay.com` },
  {
    key: `5ef6072f5da42306c50875b0`,
    value: `${src}www.ecoplexus.com`,
  },
  {
    key: `5ef6072f5da42306c50875ac`,
    value: `${src}ecogyenergy.com`,
  },
  {
    key: `5ef6072f5da42306c50875aa`,
    value: `${src}www.earthandairtech.com`,
  },
  {
    key: `5ef607335da42306c5087710`,
    value: `${src}www.lacunasustainable.com`,
  },
  {
    key: `5f072a61c3cfff0015f4d2f0`,
    value: `${src}www.innergex.com`,
  },
  { key: `5ef6073c5da42306c5087989`, value: `${src}x-elio.com` },
  {
    key: `5ef6073b5da42306c5087971`,
    value: `${src}www.vulcansolarpower.com`,
  },
  {
    key: `5ef607335da42306c5087700`,
    value: `${src}www.kennedyrenewables.co.uk`,
  },
  {
    key: `5ef6073a5da42306c5087969`,
    value: `${src}www.vision-energy.org`,
  },
  {
    key: `5ef6073a5da42306c5087965`,
    value: `${src}vgienergy.com`,
  },
  {
    key: `5ef607335da42306c50876fe`,
    value: `${src}kdcsolar.com`,
  },
  {
    key: `5ef6073a5da42306c508795f`,
    value: `${src}www.veregy.com`,
  },
  {
    key: `5ef607335da42306c50876fc`,
    value: `${src}www.kallistaenergy.com`,
  },
  {
    key: `5ef607395da42306c5087957`,
    value: `${src}velosolar.com`,
  },
  {
    key: `5ef607395da42306c5087951`,
    value: `${src}www.valorem-energie.com`,
  },
  {
    key: `5ef607395da42306c508794d`,
    value: `${src}www.usgrdco.com`,
  },
  {
    key: `5ef607395da42306c508794b`,
    value: `${src}www.urbangridsolar.com`,
  },
  { key: `5ef607395da42306c5087949`, value: `${src}u-renew.com` },
  {
    key: `5ef607395da42306c5087943`,
    value: `${src}unicosolarinvestors.com`,
  },
  {
    key: `5ef607395da42306c5087935`,
    value: `${src}truegreencapital.com`,
  },
  {
    key: `5ef6072e5da42306c5087512`,
    value: `${src}www.tridentwinds.com`,
  },
  {
    key: `5ef607395da42306c5087929`,
    value: `${src}www.triglobalenergy.com`,
  },
  {
    key: `5ef607395da42306c5087923`,
    value: `${src}tradewindenergy.com`,
  },
  {
    key: `5ef607395da42306c508791f`,
    value: `${src}www.torchcleanenergy.com`,
  },
  { key: `5ef607395da42306c508791d`, value: `${src}tja.energy` },
  {
    key: `5ef607395da42306c508791b`,
    value: `${src}www.thirdplanetwind.com`,
  },
  {
    key: `5ef6072f5da42306c5087578`,
    value: `${src}www.deshaw.com`,
  },
  {
    key: `5ef607335da42306c50876fa`,
    value: `${src}www.juhlenergy.com`,
  },
  { key: `5f04c4d9fb630400171a82f3`, value: `${src}www.nrg.com` },
  {
    key: `5ef6072f5da42306c5087574`,
    value: `${src}www.custompowersolar.com`,
  },
  {
    key: `5ef6072f5da42306c5087570`,
    value: `${src}www.csenergy.com`,
  },
  {
    key: `5ef6072f5da42306c508756a`,
    value: `${src}www.coredevusa.com`,
  },
  {
    key: `5ef6072f5da42306c5087568`,
    value: `${src}convergence-energy.com`,
  },
  {
    key: `5ef6072f5da42306c5087566`,
    value: `${src}www.contourglobal.com`,
  },
  {
    key: `5ef6072e5da42306c508755a`,
    value: `${src}www.conedsolutions.com`,
  },
  { key: `5ef6072e5da42306c5087554`, value: `${src}www.cpv.com` },
  {
    key: `5ef6072e5da42306c508753e`,
    value: `${src}www.cleanrenewablesolutions.net`,
  },
  { key: `5ef6072e5da42306c508753a`, value: `${src}cedg.us` },
  {
    key: `5ef6072e5da42306c5087538`,
    value: `${src}www.cleanenergyco.com`,
  },
  {
    key: `5ef6072e5da42306c5087534`,
    value: `${src}www.citrinepower.com`,
  },
  {
    key: `5ef6072e5da42306c5087530`,
    value: `${src}www.citizensenergy.com`,
  },
  {
    key: `5ef607325da42306c50876c0`,
    value: `${src}www.circlepowerco.com`,
  },
  {
    key: `5ef6072e5da42306c5087528`,
    value: `${src}www.charthouseenergy.com`,
  },
  {
    key: `5ef6072e5da42306c5087520`,
    value: `${src}www.cgnee.com`,
  },
  {
    key: `5ef607335da42306c50876ea`,
    value: `${src}islandpacificenergy.com`,
  },
  {
    key: `5ef6072e5da42306c5087510`,
    value: `${src}carolinasolarenergy.com`,
  },
  {
    key: `5ef6072e5da42306c508750e`,
    value: `${src}www.carbonsolutionsgroup.com`,
  },
  {
    key: `5ef6072e5da42306c5087502`,
    value: `${src}www.canopyenergy.com`,
  },
  {
    key: `5ef6072e5da42306c5087500`,
    value: `https://images.squarespace-cdn.com/content/v1/5ea71073aa088443bf538d6e/1592939837828-S8B9AGLOT0GG3764HAWB/favicon.ico?format=100w`,
  },
  {
    key: `5ef6072d5da42306c50874f2`,
    value: `${src}www.c2.energy`,
  },
  {
    key: `5ef607385da42306c508790f`,
    value: `${src}www.terna-energy.com`,
  },
  {
    key: `5ef607385da42306c5087907`,
    value: `${src}www.tatleauxsolar.com`,
  },
  {
    key: `5ef6072d5da42306c50874e8`,
    value: `${src}www.bqenergy.com`,
  },
  {
    key: `5ef6072d5da42306c50874dc`,
    value: `${src}www.bluefieldllp.com`,
  },
  {
    key: `5ef6072d5da42306c50874d8`,
    value: `${src}blueskyutility.com`,
  },
  {
    key: `5ef607385da42306c50878eb`,
    value: `${src}www.sunvest.com`,
  },
  {
    key: `5ef607385da42306c50878e9`,
    value: `${src}suntuity.com`,
  },
  {
    key: `5ef6072d5da42306c50874c6`,
    value: `${src}www.b-e-f.org`,
  },
  {
    key: `5ef6072d5da42306c50874c2`,
    value: `${src}www.baywa-re.com`,
  },
  {
    key: `5ef607385da42306c50878db`,
    value: `${src}www.sunpinsolar.us`,
  },
  {
    key: `5ef607385da42306c50878d5`,
    value: `${src}www.suneastdevelopment.com`,
  },
  {
    key: `5ef607385da42306c50878cf`,
    value: `${src}www.statkraft.com`,
  },
  {
    key: `5ef607345da42306c5087792`,
    value: `${src}www.nexteraenergy.com`,
  },
  {
    key: `5ef607385da42306c50878cb`,
    value: `${src}www.standardsolar.com`,
  },
  { key: `5ef607385da42306c50878c9`, value: `${src}sse.com` },
  {
    key: `5ef607385da42306c50878c7`,
    value: `${src}sprucefinance.com`,
  },
  {
    key: `5ef607385da42306c50878c3`,
    value: `${src}sph-solutions-llc.com`,
  },
  { key: `5ef607385da42306c50878bb`, value: `${src}solstice.us` },
  {
    key: `5fa57fdd7f02ca0015ef72f6`,
    value: `${src}communitypowerpartners.com`,
  },
  {
    key: `5fa428487739500015d5b32e`,
    value: `${src}www.windenergyoftexas.com`,
  },
  {
    key: `5ef6072e5da42306c5087540`,
    // value: `https://13snzg20cri73sadjs27bo1q-wpengine.netdna-ssl.com/wp-content/uploads/2019/12/clearway_group_logo_4c_primary.jpg`,
    value: `${img}/clearway.png`,
  },
  {
    key: `5fa2558e7bdbac0017832706`,
    value: `${src}www.geopeakenergy.com`,
  },
  {
    key: `5fa2558208f8170016071969`,
    value: `${src}www.emergentsolar.energy`,
  },
  {
    key: `5fa255730a423900168c6839`,
    value: `${src}www.solar-prime.com`,
  },
  {
    key: `5fa1833e6cf7810015d304a1`,
    value: `${src}www.hgpstorage.com`,
  },
  { key: `5fa0700d2ef552001bd63db6`, value: `${src}ncre.solar` },
  {
    key: `5fa06f0f35200a0017d03689`,
    value: `${src}blue-greenenergy.com`,
  },
  {
    key: `5fa06e8cec76aa001513b538`,
    value: `${src}www.greenenergylp.com`,
  },
  {
    key: `5fa050a8fde5d80015b5cc33`,
    value: `${src}magnumdev.com`,
  },
  {
    key: `5fa0157d2b6326001725ff59`,
    value: `${src}rerenergygroup.com`,
  },
  { key: `5f9fc9405b43c200161af50d`, value: `${src}grenergy.eu` },
  {
    key: `5f9c60a64baea80015f47988`,
    value: `${src}www.solarelectricsolutions.com`,
  },
  {
    key: `5ef607365da42306c508783d`,
    value: `${src}www.res-group.com`,
  },
  {
    key: `5f9b21ef30fd800019f00b05`,
    value: `${src}catamountsolar.com`,
  },
  {
    key: `5f9b2116612a8d0016021f8c`,
    value: `${src}norwichsolar.com`,
  },
  {
    key: `5f9ae48f135ac20015def7eb`,
    value: `${src}greenquest-solutions.com`,
  },
  {
    key: `5f9896cca133040015ab1bf5`,
    value: `${src}www.calcomenergy.com`,
  },
  {
    key: `5f9896767eee2e0015b61574`,
    value: `${src}whitepinerenewables.com`,
  },
  {
    key: `5ef607395da42306c5087939`,
    value: `${src}turningpoint-energy.com`,
  },
  {
    key: `5f9832a7d6de830015ca89b7`,
    value: `${src}renewableenergyint.com`,
  },
  {
    key: `5f98284d19f77b0015a158cb`,
    value: `${src}elanglobalrenewables.com`,
  },
  {
    key: `5f981e059adad70015a03ee4`,
    value: `${src}www.fontanaenergy.com`,
  },
  {
    key: `5f98184a39da79001578dbb9`,
    value: `${src}www.dewhurstgroup.us`,
  },
  {
    key: `5f97dd473175a20015ca3f26`,
    value: `${src}www.idealenergies.com`,
  },
  {
    key: `5f97d9462868f40015273ed5`,
    value: `${src}www.encapdevelopment.com`,
  },
  {
    key: `5f9709f82e817700158197b0`,
    value: `${src}www.cleanenergyco.com`,
  },
  {
    key: `5f96e1503d3c6b0015b57f04`,
    value: `${src}www.montanawindresources.com`,
  },
  {
    key: `5f96d93fa4ef110018d414c0`,
    value: `${src}rivermoorenergy.com`,
  },
  {
    key: `5f9314385a2f1d0016fcb206`,
    value: `${src}www.goperpetual.com`,
  },
  {
    key: `5f9313916d06220015ceec9a`,
    value: `${src}www.pfmgsolar.com`,
  },
  {
    key: `5f92b6e602d15600189c5046`,
    value: `${src}www.trilandpartners.com`,
  },
  {
    key: `5f9292ba59f0200015a6b221`,
    value: `${src}manganinc.com`,
  },
  {
    key: `5ef607385da42306c50878c5`,
    value: `${src}www.spower.com`,
  },
  {
    key: `5f91f9b086c8da0015891e75`,
    value: `${src}www.primergysolar.com`,
  },
  {
    key: `5f91f8db5794e300152148c6`,
    value: `${src}www.ls-es.com`,
  },
  {
    key: `5f91a477829b1b00158579e1`,
    value: `${src}www.influentenergy.com`,
  },
  {
    key: `5f913f26742a8300151d6a80`,
    value: `${src}www.emienergy.com`,
  },
  { key: `5f90a797560c8300176970f8`, value: `${src}gssolar.com` },
  { key: `5f90a5bb7ded1d0017c3bc0f`, value: `${src}ways2h.com` },
  {
    key: `5f9078778a87c20015e964a2`,
    value: `${src}birdseyeenergy.com`,
  },
  {
    key: `5f906e909f52fd0018cd616c`,
    value: `${src}www.floridasolarenergy.com`,
  },
  {
    key: `5f9037d6f0cb460015240d80`,
    value: `${src}www.vasolarllc.com`,
  },
  {
    key: `5f9026177ded1d0017c31b51`,
    value: `${src}oyasolar.com`,
  },
  {
    key: `5f9024569475c20015665d33`,
    value: `${src}www.ogosenergy.com`,
  },
  {
    key: `5f7b69f68d018500157a7558`,
    value: `${src}oakleafep.com`,
  },
  {
    key: `5f8f475260d3600015a5d99f`,
    value: `${src}www.r-e-services.com`,
  },
  {
    key: `5f8f46e11890240015ce24f0`,
    value: `${src}www.pd46energy.com`,
  },
  {
    key: `5f8f376f05bdc100158e5e51`,
    value: `${src}www.clemgeo.com`,
  },
  {
    key: `5f8e886fe464030015bfa258`,
    value: `${src}www.uka-group.com`,
  },
  {
    key: `5f8de64bc7b7ed0015bb2636`,
    value: `${src}www.bluestemenergysolutions.com`,
  },
  {
    key: `5f8c2347dd671f0016980f36`,
    value: `${src}www.directionalservices.net`,
  },
  {
    key: `5f89ca08c7f02a0015db22f6`,
    value: `${src}www.sagesrst.com`,
  },
  {
    key: `5f885da521681100158718fb`,
    value: `${src}www.boreal-renewable.com`,
  },
  {
    key: `5f884d08eeedca0016ead524`,
    value: `${src}www.advancedhydrosolutions.com`,
  },
  {
    key: `5f884655adfd460016a0bdf8`,
    value: `${src}www.chaberton.com`,
  },
  {
    key: `5ef607315da42306c5087650`,
    value: `${src}nationalgridrenewables.com`,
  },
  {
    key: `5f875515b673ba00152cefce`,
    value: `${src}www.brightfieldenergy.com`,
  },
  {
    key: `5f87445bfcaba100155cff64`,
    value: `${src}brighterenergy.us`,
  },
  {
    key: `5f8742c2e6a8590016fc47b7`,
    value: `${src}www.tvnrg.com`,
  },
  {
    key: `5f873a97c2757c0015183a44`,
    value: `${src}waldengreenenergy.com`,
  },
  {
    key: `5f8730f76f8ba6001810a765`,
    value: `${src}www.aluminaenergy.com`,
  },
  {
    key: `5f872dac41c4ff0019a8a093`,
    value: `${src}vermaland.com`,
  },
  {
    key: `5f872689f593c60015631f5b`,
    value: `${src}www.transmissiondevelopers.com`,
  },
  {
    key: `5f85fb50eb22a700177b2790`,
    value: `${src}www.americanrenewable.com`,
  },
  {
    key: `5f85fa015ade4b0019e26874`,
    value: `${src}www.allcous.com`,
  },
  {
    key: `5f85e0d35aa4590016d54f73`,
    value: `${src}www.lavaridgewind.com`,
  },
  {
    key: `5f85de33dd7abd0016483665`,
    value: `${src}www.tridentenergy.com`,
  },
  {
    key: `5f85ddd587e2400015c32c69`,
    value: `${src}www.synergensolar.com`,
  },
  {
    key: `5f85a87365e9770016ef299e`,
    value: `${src}www.spigroups.com`,
  },
  {
    key: `5f7f6df73083f30015c7ad5b`,
    value: `${src}tripleoakpower.com`,
  },
  {
    key: `5f7f547986ac2600182d0cde`,
    value: `${src}www.concentricpower.com`,
  },
  {
    key: `5f75a27c83102500157508b1`,
    value: `${src}macstellar.com`,
  },
  {
    key: `5f7439f2e89b5900157265d2`,
    value: `${src}www.cdnrg.com`,
  },
  {
    key: `5f7331fc7899700015fb269f`,
    value: `${src}www.windadvantage.com`,
  },
  {
    key: `5f75af5e07e13300155ed4ed`,
    value: `${src}www.amergysolar.com`,
  },
  {
    key: `5f75b077d9ede30016ffccf4`,
    value: `${src}www.greenpowerdeveloperslimited.com`,
  },
  {
    key: `5f745e85e89b590015729c3c`,
    value: `${src}www.wellhead.com`,
  },
  {
    key: `5f7325ecd347750015ba2730`,
    value: `${src}www.bnbrenewables.com`,
  },
  {
    key: `5f7dbbfe4f69f70016b3bbf5`,
    value: `${src}www.jupiterpower.io`,
  },
  { key: `5f7dbd7dc3b806001628bcd0`, value: `${src}nrstor.com` },
  {
    key: `5f7dba69b20f2f0015b07310`,
    value: `${src}www.cvegroup.com`,
  },
  {
    key: `5ef607385da42306c50878bd`,
    value: `${src}www.soltage.com`,
  },
  {
    key: `5ef6072d5da42306c50874b8`,
    value: `${src}www.avantenergy.com`,
  },
  {
    key: `5ef607385da42306c50878b9`,
    value: `${src}www.solops.com`,
  },
  { key: `5ef607385da42306c50878b7`, value: `${src}solect.com` },
  {
    key: `5ef607375da42306c50878b3`,
    value: `${src}www.solarpack.es`,
  },
  {
    key: `5ef607375da42306c50878a9`,
    value: `${src}www.solarsolutiondc.com`,
  },
  {
    key: `5ef607375da42306c50878a5`,
    value: `${src}srenergyllc.com`,
  },
  {
    key: `5ef607375da42306c5087899`,
    value: `${src}www.solsystems.com`,
  },
  {
    key: `5ef607375da42306c5087897`,
    value: `${src}www.sofosharbert.com`,
  },
  {
    key: `5ef6072d5da42306c50874a2`,
    value: `${src}www.areviapower.com`,
  },
  {
    key: `5ef6072d5da42306c5087494`,
    value: `${src}www.apexcleanenergy.com`,
  },
  {
    key: `5ef607375da42306c5087893`,
    value: `${src}www.skylinerenewables.com`,
  },
  { key: `5ef607335da42306c50876e2`, value: `${src}undefined` },
  { key: `5ef6072c5da42306c508748e`, value: `${src}anbaric.com` },
  {
    key: `5ef607375da42306c5087889`,
    value: `${src}www.simpleray.com`,
  },
  {
    key: `5ef6072c5da42306c5087486`,
    value: `${src}www.amped-solutions.com`,
  },
  { key: `5ef6072c5da42306c5087484`, value: `${src}amp.energy` },
  {
    key: `5ef607375da42306c5087887`,
    value: `${src}www.siliconranch.com`,
  },
  {
    key: `5ef607375da42306c508787d`,
    value: `${src}www.shorebreakenergy.com`,
  },
  {
    key: `5ef6072c5da42306c508747d`,
    value: `${src}www.ameresco.com`,
  },
  {
    key: `5ef6072c5da42306c5087479`,
    value: `${src}www.altuspower.com`,
  },
  {
    key: `5ef6072c5da42306c5087475`,
    value: `${src}alphawind.dk`,
  },
  {
    key: `5ef6072c5da42306c5087473`,
    value: `${src}www.alphaenergyinc.com`,
  },
  {
    key: `5ef607375da42306c5087871`,
    value: `${src}securefutures.solar`,
  },
  {
    key: `5ef607375da42306c508786f`,
    value: `${src}sdc-energy.com`,
  },
  {
    key: `5ef607375da42306c508786b`,
    value: `${src}www.scoutcleanenergy.com`,
  },
  {
    key: `5ef607375da42306c5087865`,
    value: `${src}www.scenichillsolar.com`,
  },
  {
    key: `5ef607375da42306c5087863`,
    value: `${src}www.sbenergy.co.jp`,
  },
  {
    key: `5ef607375da42306c5087861`,
    value: `${src}savionenergy.com`,
  },
  {
    key: `5ef607375da42306c508785d`,
    value: `${src}www.saturnpower.com`,
  },
  {
    key: `5ef6072c5da42306c5087461`,
    value: `${src}www.alchemyenergy.com`,
  },
  {
    key: `5ef607375da42306c5087857`,
    value: `${src}safarienergy.com`,
  },
  {
    key: `5ef607375da42306c5087855`,
    value: `${src}www.saetayield.com`,
  },
  {
    key: `5ef607365da42306c508784d`,
    value: `${src}www.ryedevelopment.com`,
  },
  {
    key: `5ef607335da42306c50876dc`,
    value: `${src}www.integratedsolaroperations.com`,
  },
  {
    key: `5ef607365da42306c5087845`,
    value: `${src}rooftopsolar.us`,
  },
  {
    key: `5ef6072c5da42306c5087458`,
    value: `${src}www.affordablecommunityenergyservices.com`,
  },
  {
    key: `5ef6072c5da42306c5087454`,
    value: `${src}aesdistributedenergy.com`,
  },
  { key: `5ef6072c5da42306c5087452`, value: `${src}www.aes.com` },
  {
    key: `5ef6072c5da42306c508744a`,
    value: `${src}www.advancedsolarproducts.com`,
  },
  {
    key: `5ef6072c5da42306c5087448`,
    value: `${src}advancedpower.ch`,
  },
  {
    key: `5ef607335da42306c50876da`,
    value: `${src}www.inovateus.com`,
  },
  {
    key: `5ef607335da42306c50876d6`,
    value: `${src}ips-solar.com`,
  },
  {
    key: `5ef6072c5da42306c5087442`,
    value: `${src}acellcsolar.com`,
  },
  {
    key: `5ef607325da42306c50876d2`,
    value: `${src}www.inmansolar.com`,
  },
  {
    key: `5ef6072c5da42306c508743c`,
    value: `${src}abovegridsolar.com`,
  },
  {
    key: `5ef6072c5da42306c508743a`,
    value: `${src}www.ablegridenergy.com`,
  },
  {
    key: `5ef607365da42306c508783f`,
    value: `${src}rhynland.com`,
  },
  {
    key: `5ef607365da42306c508783b`,
    value: `${src}www.renewableenergypartnersllc.com`,
  },
  {
    key: `5ef6072c5da42306c5087438`,
    value: `${src}www.abengoa.com`,
  },
  {
    key: `5ef607325da42306c50876d0`,
    value: `${src}www.infinitienergyservices.net`,
  },
  {
    key: `5ef607365da42306c5087835`,
    value: `${src}thinkrenew.com`,
  },
  {
    key: `5ef607365da42306c508782f`,
    value: `${src}regreencorp.com`,
  },
  {
    key: `5ef607365da42306c5087829`,
    value: `${src}recurrentenergy.com`,
  },
  {
    key: `5ef607365da42306c5087825`,
    value: `${src}www.rangerpower.com`,
  },
  {
    key: `5ef607325da42306c50876c2`,
    value: `${src}www.ibvogt.com`,
  },
  {
    key: `5ef6072c5da42306c5087434`,
    value: `${src}www.abatispower.com`,
  },
  { key: `5f6b824397d9100016b8edd9`, value: `${src}deepcorp.ca` },
  {
    key: `60f9587f102a1b001fdc699a`,
    value: `${src}newenergyblue.com`,
  },
  {
    key: `5f048a1191d5aa0015dcd64e`,
    value: `${src}www.engie.com`,
  },
  {
    key: `60630aa5cdbe860020c6e01f`,
    value: `${src}www.smartwires.com`,
  },
  {
    key: `60619936573d98001b7248d4`,
    value: `${src}www.huntconsolidated.com`,
  },
  {
    key: `5ef6072d5da42306c50874b6`,
    value: `${src}www.avangrid.com`,
  },

  {
    key: `605cc14c289bcf001e02c971`,
    value: `${src}www.corporationwiki.com`,
  },
  {
    key: `605c5f81a1e9dd001b2b01f6`,
    value: `${src}www.standardhydrogencorp.com`,
  },
  {
    key: `605b08f974b832001be01504`,
    value: `${src}catalyze.energy`,
  },
  { key: `6054a6c5b650c8001b2fa032`, value: `${src}www.ceg.mn` },
  {
    key: `60549b71147ab7001e6ca1ab`,
    value: `${src}www.thewindpower.net`,
  },
  {
    key: `60535da98ee010001b6851fc`,
    value: `${src}www.kroaddg.com`,
  },
  {
    key: `60534aa223a98d001cba54fa`,
    value: `${src}www.dmggroup.net`,
  },
  {
    key: `6051cce5817eaa001b992f0c`,
    value: `${src}www.edprnadg.com`,
  },
  {
    key: `6051d622522ba4001fe0be04`,
    value: `${src}seahorsellc.com`,
  },
  {
    key: `6051d00f81a2d3001b6471e7`,
    value: `${src}www.cleantech.com`,
  },
  {
    key: `6051cdd7d32e7a001e39457a`,
    value: `${src}www.sa.areva.com`,
  },
  {
    key: `6050d5c67b533e001b707152`,
    value: `${src}www.cpc-germania.com`,
  },
  {
    key: `6050cfb94438cb001be4da3b`,
    value: `${src}leapshydro.com`,
  },
  {
    key: `6050905a73b399001ba93ab8`,
    value: `${src}silveradocompany.com`,
  },
  {
    key: `604a595de06b39001b50b8e6`,
    value: `${src}ismsolardev.com`,
  },
  {
    key: `604a065e5c1cad001b8e75dc`,
    value: `${src}innovative-ess.com`,
  },
  {
    key: `604a054a1cf5c5001b330a49`,
    value: `${src}www.tuusso.com`,
  },
  {
    key: `604a04a33fd94c001b093b2e`,
    value: `${src}www.swebdevelopment.ca`,
  },
  {
    key: `6042049bca1887001cb4873f`,
    value: `${src}noriaenergy.com`,
  },
  { key: `6049eb340a8511001b5e6c8f`, value: `${src}tugliq.com` },
  {
    key: `6048b1a939a04e001e9fe149`,
    value: `${src}www.treadwood.com`,
  },
  {
    key: `604778c8cf4869001b2264f5`,
    value: `${src}www.sun2o.com`,
  },
  {
    key: `604756cb12239a001baed457`,
    value: `${src}www.peiec.ca`,
  },
  {
    key: `60474e5412239a001baec9c4`,
    value: `${src}www.nebatterystorage.com`,
  },
  {
    key: `60462a2faef896001ba3eb1d`,
    value: `${src}www.tcirenewables.com`,
  },
  {
    key: `6045e87bebcf41001be353f5`,
    value: `${src}www.sensiblesolarny.org`,
  },
  {
    key: `60411acd36d1c2001ba928dc`,
    value: `${src}www.keystoneph.com`,
  },
  {
    key: `5ef6072c5da42306c5087428`,
    value: `${src}www.5starsolar.website`,
  },
  {
    key: `603f602db324ef001b118d20`,
    value: `${src}carbonfree.com`,
  },
  {
    key: `603f5f9f8e9edc001b82fb68`,
    value: `${src}solargreendevelopment.com`,
  },
  {
    key: `6038e20f842a20001c655d4d`,
    value: `${src}smtenergy.com`,
  },
  { key: `6034f27296f93f001c6a5a3c`, value: `${src}undefined` },
  {
    key: `5f174c19bbc4580016c243db`,
    value: `${src}www.clenera.com`,
  },
  {
    key: `602d2ddd6192da001cefc5f4`,
    value: `${src}teichosenergy.com`,
  },
  {
    key: `602d13b21aefff001cadea0b`,
    value: `${src}www.oaksquarepartners.com`,
  },
  {
    key: `602b74fdbe5c92001bfdb4e6`,
    value: `${src}www.sansurre.com`,
  },
  {
    key: `6026a28bf200f5001b4ebee8`,
    value: `${src}nytransco.com`,
  },
  {
    key: `60269e5befb434001bbf4a90`,
    value: `${src}www.patriotrenewables.com`,
  },
  {
    key: `602556f3edb474001b9b60f0`,
    value: `${src}www.biogascorp.com`,
  },
  {
    key: `60244e29ba9e16001c50cf4b`,
    value: `${src}www.nteenergy.com`,
  },
  {
    key: `601d2f940e9fa4001e922f92`,
    value: `${src}eolectric.com`,
  },
  { key: `601c1c551077ce0021e53c89`, value: `${src}openei.org` },
  {
    key: `601bdf0172cc89001bc34490`,
    value: `${src}catalystpower.com`,
  },
  {
    key: `601bc1d872aa07001b2d85d9`,
    value: `${src}www.cogentrix.com`,
  },
  {
    key: `601ac1911dd63b001b9efabb`,
    value: `${src}solvedbymomentum.com`,
  },
  {
    key: `5ef6073b5da42306c5087973`,
    value: `${src}www.waldenrenewables.com`,
  },
  {
    key: `6017e78930242b001b53febf`,
    value: `${src}effisolar.ca`,
  },
  {
    key: `60132ee914b28a001c2bd8fa`,
    value: `${src}www.absarokaenergy.com`,
  },
  { key: `60128a48ad52eb001bc60de3`, value: `${src}undefined` },
  {
    key: `60116b41398bf7001b1ebe14`,
    value: `${src}infiniumco.com`,
  },
  {
    key: `601169def3593c001bd41f03`,
    value: `${src}www.akonlightingamerica.com`,
  },
  {
    key: `600f25a86fc2c1001b988923`,
    value: `${src}sealsolar.com`,
  },
  {
    key: `600858dd50e98a001cf74825`,
    value: `${src}www.deloreanpower.com`,
  },
  { key: `6007371b2a8858001dfaabe2`, value: `${src}undefined` },
  {
    key: `6002c21ec67b4d001e71f2b7`,
    value: `${src}www.abo-wind.com`,
  },
  {
    key: `600084f7a5c4cb001b8a924c`,
    value: `${src}wolfeenergy.com`,
  },
  { key: `5ffc402f6a0615001bf9935d`, value: `${src}wirsol.com` },
  {
    key: `5ff84a371a77650021e5f02d`,
    value: `${src}www.infigenenergy.com`,
  },
  {
    key: `5fdb5c096e906f001ba9fcf3`,
    value: `${src}www.reddogholdingsltd.com`,
  },
  {
    key: `5f7c59a6d14d660016ad4e7c`,
    value: `${src}perimetersolar.ca`,
  },
  {
    key: `5fdbbe55e40bba0020f98b1d`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5f9155ee8e27ed0015de8638`,
    value: `${src}www.cleantechnologycapital.com`,
  },
  {
    key: `5ef607365da42306c508780f`,
    value: `${src}prismpowerpartners.com`,
  },
  {
    key: `5ef607355da42306c50877cf`,
    value: `${src}www.ourgeneration.dev`,
  },
  {
    key: `5f83698cf1c06300168aeafa`,
    value: `${src}www.addstarpower.com`,
  },
  {
    key: `5f2c239654b3e50015949724`,
    value: `${src}www.bloomberg.com`,
  },
  {
    key: `5ff4d987498b7a001b5dd848`,
    value: `${src}www.synex.com`,
  },
  {
    key: `5ff4b158aa0344001b97d6ea`,
    value: `${src}www.enersmartstorage.com`,
  },
  {
    key: `5fdba0945686d6001b307760`,
    value: `${src}arevonenergy.com`,
  },
  {
    key: `5feb7e52d8fdb6001c00a073`,
    value: `${src}www.shikunbinui.com`,
  },
  {
    key: `5ef607355da42306c50877b8`,
    value: `${src}www.oneenergyrenewables.com`,
  },
  {
    key: `5fe4aa2a9f941d001b7de3d9`,
    value: `${src}mynoblesolar.com`,
  },
  {
    key: `5fe3991a9b6c22001b14bc20`,
    value: `${src}www.nexusrenewables.com`,
  },
  {
    key: `5fe38ad1aea04a001b542dfe`,
    value: `${src}www.etcapital.us`,
  },
  {
    key: `5ef6072c5da42306c508746b`,
    value: `${src}alletecleanenergy.com`,
  },
  {
    key: `5fe05c5759547d001b0f69d6`,
    value: `${src}nokomisenergy.com`,
  },
  { key: `5fdd04a5caa648001b4badb1`, value: `${src}www.dnb.com` },
  {
    key: `5fdbb6c372aa9b001b8c7a5e`,
    value: `${src}www.wkn-group.com`,
  },
  {
    key: `5fdbb7133ccfb4001c7f14cd`,
    value: `${src}www.pne-usa.com`,
  },
  { key: `5fda5275204f03001b8ee493`, value: `${src}uniland.com` },
  {
    key: `5fda43e7f002a2001e03df44`,
    value: `${src}www.rrepower.com`,
  },
  {
    key: `5fda3f7616831a001c222861`,
    value: `${src}www.greenleaftnx.com`,
  },
  {
    key: `5fda383de7cfa6001b07ea7d`,
    value: `${src}opencorporates.com`,
  },
  { key: `5fd900a9253be5001c61ad53`, value: `${src}fnpa.ca` },
  {
    key: `5fd71986eaa210001b6b91aa`,
    value: `${src}uslightenergy.com`,
  },
  {
    key: `5fd71778c9502b001bc3dae1`,
    value: `${src}www.canopyenergy.com`,
  },
  {
    key: `5fd712ecacd775001c1ad978`,
    value: `${src}www.enerparc.de`,
  },
  {
    key: `5fd3bbf6f22779001b2f7db5`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5fd3b399a59529001ce9d29d`,
    value: `${src}northrenew.com`,
  },
  {
    key: `5fd391801726ac001bd97513`,
    value: `${src}www.atlanticshoreswind.com`,
  },
  { key: `5fd2766c4b3790001b0a5c24`, value: `${src}nextchem.it` },
  {
    key: `5fd275ca4b3790001b0a5ae6`,
    value: `${src}fgepower.com`,
  },
  {
    key: `5fd26de75d759d001cec1880`,
    value: `${src}www.puc.texas.gov`,
  },
  {
    key: `5fd26af83b482b001b5fe443`,
    value: `${src}www.diodeventures.com`,
  },
  {
    key: `5fd26a8d15d512001beb98b8`,
    value: `${src}www.dflexpower.com`,
  },
  {
    key: `5fd253a46b7966001ba3dc9c`,
    value: `${src}www.bizapedia.com`,
  },
  {
    key: `5ef6072d5da42306c50874d6`,
    value: `${src}www.blueskysolarco.com`,
  },
  {
    key: `5fd13cad9f6aff001b70312f`,
    value: `${src}www.bordasenergy.com`,
  },
  {
    key: `5fd13b262b3ade001bf07f62`,
    value: `${src}onpeakpower.com/`,
  },
  {
    key: `5fd0fd611f6c43001e9190a8`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5f83678cd5eac60015b12c6a`,
    value: `${src}www.corporationwiki.com`,
  },
  {
    key: `5fd0dcebbb966c001bbc04dc`,
    value: `${src}edelenrenewables.com`,
  },
  {
    key: `60fe37ca42e36d00205a634f`,
    value: `${src}www.greenipi.com`,
  },
  {
    key: `60fe9de44c3208001ed2d7b2`,
    value: `${src}southerncarolina.org`,
  },
  {
    key: `60fe623e5e595900225cade7`,
    value: `${src}lfbioenergy.com`,
  },
  {
    key: `60fea3607b1d5e001e5df5d3`,
    value: `${src}vanguardrenewables.com`,
  },
  {
    key: `60ffde6078d431001f534e06`,
    value: `${src}powerbridge.us`,
  },
  {
    key: `60ffcb881d230d001e79ab4e`,
    value: `${src}www.atlanticrenewableenergy.com`,
  },
  {
    key: `60ffb339264b7b001e705a22`,
    value: `${src}broadviewenergy.com`,
  },
  {
    key: `61025197cdb81d001fb34146`,
    value: `${src}www.federalregister.gov`,
  },
  { key: `6101954e019abb002183c169`, value: `${src}rudarpa.com` },
  {
    key: `5ef6072d5da42306c50874c8`,
    value: `${src}belltownpower.com`,
  },
  {
    key: `5f1841a49c0aee001584422e`,
    value: `${src}www.engie-na.com`,
  },
  {
    key: `61028634f1cb78002020ad05`,
    value: `${src}www.wyomingnews.com`,
  },
  {
    key: `60ae4414ab1881001f464bbd`,
    value: `${src}liberty-renewables.com`,
  },
  {
    key: `6102b6c7140ec400209f4b31`,
    value: `${src}www.bizapedia.com`,
  },
  {
    key: `5f1b01c12b82b6001516b596`,
    value: `${src}www.solar-reserve.com`,
  },
  {
    key: `5f1b398b911fc40015ce5ebe`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5f1b18b462db5e0015adb8eb`,
    value: `${src}www.thewindpower.net`,
  },
  {
    key: `5f29a598499f7e0018e82fd9`,
    value: `${src}www.rplusenergies.com`,
  },
  {
    key: `5f1b12d845c4be00156d46a1`,
    value: `${src}www.shell.com`,
  },
  {
    key: `5f1b186e911fc40015ce3943`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5f1b0c9045c4be00156d167d`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5f1b12318bfdce0017031238`,
    value: `${src}www.apexcleanenergy.com`,
  },
  {
    key: `5f1b0fc745c4be00156d2f62`,
    value: `${src}www.norvento.com`,
  },
  { key: `6103e6cc4f12aa001e0e5ed7`, value: `${src}aequatis.co` },
  { key: `5f1b05256166c5001685fc75`, value: `${src}amshore.com` },
  {
    key: `5f1b04376166c5001685f7d5`,
    value: `${src}windatallc.wordpress.com`,
  },
  {
    key: `5f1b09f56166c50016860ca6`,
    value: `${src}www.edf-re.com`,
  },
  {
    key: `5f1b06096166c5001685ff6b`,
    value: `${src}castlewind.com`,
  },
  {
    key: `5f1b0c1b2b82b6001516c732`,
    value: `${src}www.mainstreamrp.com`,
  },
  {
    key: `5f1b067945c4be00156cef77`,
    value: `${src}chermacenergy.com`,
  },
  {
    key: `61040cea7edbed001e5bed02`,
    value: `${src}www.cep-solar.com`,
  },
  {
    key: `6107953f3bec8d001e8a124f`,
    value: `${src}www.biofinetechnology.com`,
  },
  {
    key: `610798deaff52e001eee0d97`,
    value: `${src}www.biofinedevelopments.com`,
  },
  {
    key: `61091a2e85053b001e54594b`,
    value: `${src}www.ever-greenenergy.com`,
  },
  {
    key: `5fac241c17ea500015e6daad`,
    value: `${src}www.oceanwinds.com`,
  },
  {
    key: `610bbc47990255002091b5d6`,
    value: `${src}redeuxenergy.com`,
  },
  {
    key: `5f15f05182dfe5001598f5ec`,
    value: `${src}alterraenergy.com`,
  },
  {
    key: `610bdc99c10bc5001e550f1a`,
    value: `${src}www.dcoenergy.com`,
  },
  {
    key: `610a4a2ad7e5c5001e05cf2b`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `5f96ed55b040780017863074`,
    value: `${src}www.archaeaenergy.com`,
  },
  {
    key: `61111e441d91b0001f9a8949`,
    value: `${src}glidepath.net`,
  },
  { key: `5f319625833a4e001521ef4e`, value: `${src}undefined` },
  {
    key: `6111165995e098001f32f7d9`,
    value: `${src}homelandfuelscompany.com`,
  },
  {
    key: `6111079f1d91b0001f9a67d9`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `6110e551100828001e98441c`,
    value: `${src}laketricity-fpv.com`,
  },
  {
    key: `611105fd100828001e987c4a`,
    value: `${src}www.dpenergy.com`,
  },
  {
    key: `610d1d28a0df0c001e7e2dc3`,
    value: `${src}www.balancedrockpower.com`,
  },
  {
    key: `5f23138171dd10001876c8a0`,
    value: `${src}gegrenewables.com`,
  },
  {
    key: `5fca50f7061fd9001b40173a`,
    value: `${src}castlemanpower.com`,
  },
  {
    key: `610aa05abe1b8f001efabf07`,
    value: `${src}www.midwestagenergy.com`,
  },
  {
    key: `610a7266cd748b001e74caa2`,
    value: `${src}canarybiofuels.com`,
  },
  {
    key: `610954b68bf397001fc6a086`,
    value: `${src}meagercreek.ca`,
  },
  {
    key: `61091b12a9f22e001e982ad8`,
    value: `${src}investor.clearwayenergy.com`,
  },
  { key: `6112319a3dee5c002114fb1d`, value: `${src}gevo.com` },
  {
    key: `61124885a9003c001e71021c`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `61125d083f643b001eed8d44`,
    value: `${src}americas.rwe.com`,
  },
  {
    key: `611261b87e8c1f001eab1d59`,
    value: `${src}www.wattbridge.info`,
  },
  { key: `61138353dbb87d001eff2fd2`, value: `${src}www.ril.com` },
  { key: `6113dc45c56d83001e631811`, value: `${src}undefined` },
  {
    key: `6113a453205555001e19c806`,
    value: `${src}tidalenergycorp.com`,
  },
  {
    key: `6114d3295dd245001e382f30`,
    value: `${src}strategicbiofuels.net`,
  },
  {
    key: `6113dd6f23b7ed001e6a20f1`,
    value: `${src}en.wikipedia.org`,
  },
  {
    key: `6114a1d5697cc4001e397fc1`,
    value: `${src}cornerstonerenewables.ca`,
  },
  {
    key: `6114f9e1fac368001fa55b68`,
    value: `${src}opencorporates.com`,
  },
  {
    key: `611621d1dfc76b001e679b6d`,
    value: `${src}www.aurorasolar.com`,
  },
  {
    key: `61162973c3723d001e835472`,
    value: `${src}mas-energy.com`,
  },
  {
    key: `61164398ad3da4001ee25843`,
    value: `${src}peakpowerenergy.com`,
  },
  {
    key: `61163cd9bde3e300201d29db`,
    value: `${src}www.modern.energy`,
  },
  {
    key: `61163b84c3723d001e836e3c`,
    value: `${src}buenavistarenewables.com`,
  },
  {
    key: `611639d1abe78f0020a27ec2`,
    value: `${src}www.echogen.com`,
  },
]
